import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";

var _Ar, _Ln, _$n, _ui, _vi, _Vi, _ul;

var _excluded = ["static"],
    _excluded2 = ["unmount"],
    _excluded3 = ["as", "children", "refName"],
    _excluded4 = ["value", "onChange", "disabled"],
    _excluded5 = ["value", "onChange", "displayValue"],
    _excluded6 = ["hold"],
    _excluded7 = ["disabled", "value"],
    _excluded8 = ["target"],
    _excluded9 = ["open", "onClose", "initialFocus"],
    _excluded10 = ["defaultOpen"],
    _excluded11 = ["initialFocus"],
    _excluded12 = ["value", "onChange", "disabled", "horizontal"],
    _excluded13 = ["disabled", "value"],
    _excluded14 = ["disabled", "onClick"],
    _excluded15 = ["focus"],
    _excluded16 = ["passive"],
    _excluded17 = ["value", "onChange", "disabled"],
    _excluded18 = ["value", "disabled"],
    _excluded19 = ["checked", "onChange"],
    _excluded20 = ["defaultIndex", "vertical", "manual", "onChange", "selectedIndex"],
    _excluded21 = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"],
    _excluded22 = ["show", "appear", "unmount"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/app/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import xt, { Fragment as Cr, createContext as lo, createRef as Ge, useCallback as B, useContext as ao, useMemo as oe, useReducer as Sr, useRef as He } from "react";
import { useState as Yo, useEffect as Xo } from "react";

function k() {
  var e = [],
      t = [],
      r = {
    enqueue: function enqueue(o) {
      t.push(o);
    },
    requestAnimationFrame: function (_requestAnimationFrame) {
      function requestAnimationFrame() {
        return _requestAnimationFrame.apply(this, arguments);
      }

      requestAnimationFrame.toString = function () {
        return _requestAnimationFrame.toString();
      };

      return requestAnimationFrame;
    }(function () {
      var n = requestAnimationFrame.apply(void 0, arguments);
      r.add(function () {
        return cancelAnimationFrame(n);
      });
    }),
    nextFrame: function nextFrame() {
      for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
        o[_key] = arguments[_key];
      }

      r.requestAnimationFrame(function () {
        r.requestAnimationFrame.apply(r, o);
      });
    },
    setTimeout: function (_setTimeout) {
      function setTimeout() {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function () {
      var n = setTimeout.apply(void 0, arguments);
      r.add(function () {
        return clearTimeout(n);
      });
    }),
    add: function add(o) {
      e.push(o);
    },
    dispose: function dispose() {
      var _iterator = _createForOfIteratorHelper(e.splice(0)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var o = _step.value;
          o();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    workQueue: function workQueue() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator2, _step2, o;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iterator2 = _createForOfIteratorHelper(t.splice(0));
                _context.prev = 1;

                _iterator2.s();

              case 3:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 9;
                  break;
                }

                o = _step2.value;
                _context.next = 7;
                return o();

              case 7:
                _context.next = 3;
                break;

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);

                _iterator2.e(_context.t0);

              case 14:
                _context.prev = 14;

                _iterator2.f();

                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11, 14, 17]]);
      }))();
    }
  };
  return r;
}

function Q() {
  var _Yo = Yo(k),
      _Yo2 = _slicedToArray(_Yo, 1),
      e = _Yo2[0];

  return Xo(function () {
    return function () {
      return e.dispose();
    };
  }, [e]), e;
}

import { useState as tr } from "react";
import { useLayoutEffect as Jo, useEffect as Zo } from "react";
var x = typeof window != "undefined" ? Jo : Zo;
import { useState as er, useEffect as eo } from "react";
var yt = {
  serverHandoffComplete: !1
};

function q() {
  var _er = er(yt.serverHandoffComplete),
      _er2 = _slicedToArray(_er, 2),
      e = _er2[0],
      t = _er2[1];

  return eo(function () {
    e !== !0 && t(!0);
  }, [e]), eo(function () {
    yt.serverHandoffComplete === !1 && (yt.serverHandoffComplete = !0);
  }, []), e;
}

var or = 0;

function to() {
  return ++or;
}

function A() {
  var e = q(),
      _tr = tr(e ? to : null),
      _tr2 = _slicedToArray(_tr, 2),
      t = _tr2[0],
      r = _tr2[1];

  return x(function () {
    t === null && r(to());
  }, [t]), t != null ? "" + t : void 0;
}

import { useState as ir } from "react";
import { useRef as rr, useEffect as nr } from "react";

function ke(e) {
  var t = rr(e);
  return nr(function () {
    t.current = e;
  }, [e]), t;
}

function ee(e, t) {
  var _ir = ir(e),
      _ir2 = _slicedToArray(_ir, 2),
      r = _ir2[0],
      o = _ir2[1],
      n = ke(e);

  return x(function () {
    return o(n.current);
  }, [n, o].concat(_toConsumableArray(t))), r;
}

import { useRef as lr, useEffect as ar, useCallback as sr } from "react";

function I() {
  for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    e[_key2] = arguments[_key2];
  }

  var t = lr(e);
  return ar(function () {
    t.current = e;
  }, [e]), sr(function (r) {
    var _iterator3 = _createForOfIteratorHelper(t.current),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var o = _step3.value;
        o != null && (typeof o == "function" ? o(r) : o.current = r);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }, [t]);
}

import { Fragment as oo, cloneElement as ur, createElement as pr, forwardRef as dr, isValidElement as cr } from "react";

function S(e, t) {
  if (e in t) {
    var n = t[e];

    for (var _len3 = arguments.length, r = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      r[_key3 - 2] = arguments[_key3];
    }

    return typeof n == "function" ? n.apply(void 0, r) : n;
  }

  var o = new Error("Tried to handle \"".concat(e, "\" but there is no handler defined. Only defined handlers are: ").concat(Object.keys(t).map(function (n) {
    return "\"".concat(n, "\"");
  }).join(", "), "."));
  throw Error.captureStackTrace && Error.captureStackTrace(o, S), o;
}

function E(_ref) {
  var e = _ref.props,
      t = _ref.slot,
      r = _ref.defaultTag,
      o = _ref.features,
      _ref$visible = _ref.visible,
      n = _ref$visible === void 0 ? !0 : _ref$visible,
      i = _ref.name;
  if (n) return _e(e, t, r, i);
  var a = o != null ? o : 0;

  if (a & 2) {
    var _e$static = e.static,
        l = _e$static === void 0 ? !1 : _e$static,
        s = _objectWithoutProperties(e, _excluded);

    if (l) return _e(s, t, r, i);
  }

  if (a & 1) {
    var _S;

    var _e$unmount = e.unmount,
        _l = _e$unmount === void 0 ? !0 : _e$unmount,
        _s = _objectWithoutProperties(e, _excluded2);

    return S(_l ? 0 : 1, (_S = {}, _defineProperty(_S, 0, function _() {
      return null;
    }), _defineProperty(_S, 1, function _() {
      return _e(_objectSpread(_objectSpread({}, _s), {}, {
        hidden: !0,
        style: {
          display: "none"
        }
      }), t, r, i);
    }), _S));
  }

  return _e(e, t, r, i);
}

function _e(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r = arguments.length > 2 ? arguments[2] : undefined;
  var o = arguments.length > 3 ? arguments[3] : undefined;

  var _gt = gt(e, ["unmount", "static"]),
      _gt$as = _gt.as,
      n = _gt$as === void 0 ? r : _gt$as,
      i = _gt.children,
      _gt$refName = _gt.refName,
      a = _gt$refName === void 0 ? "ref" : _gt$refName,
      l = _objectWithoutProperties(_gt, _excluded3),
      s = e.ref !== void 0 ? _defineProperty({}, a, e.ref) : {},
      u = typeof i == "function" ? i(t) : i;

  if (l.className && typeof l.className == "function" && (l.className = l.className(t)), n === oo && Object.keys(l).length > 0) {
    if (!cr(u) || Array.isArray(u) && u.length > 1) throw new Error(['Passing props on "Fragment"!', "", "The current component <".concat(o, " /> is rendering a \"Fragment\"."), "However we need to passthrough the following props:", Object.keys(l).map(function (c) {
      return "  - ".concat(c);
    }).join("\n"), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map(function (c) {
      return "  - ".concat(c);
    }).join("\n")].join("\n"));
    return ur(u, Object.assign({}, fr(mr(gt(l, ["ref"])), u.props, ["onClick"]), s));
  }

  return pr(n, Object.assign({}, gt(l, ["ref"]), n !== oo && s), u);
}

function fr(e, t, r) {
  var o = Object.assign({}, e);

  var _iterator4 = _createForOfIteratorHelper(r),
      _step4;

  try {
    var _loop = function _loop() {
      var n = _step4.value;
      e[n] !== void 0 && t[n] !== void 0 && Object.assign(o, _defineProperty({}, n, function (i) {
        i.defaultPrevented || e[n](i), i.defaultPrevented || t[n](i);
      }));
    };

    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return o;
}

function D(e) {
  var t;
  return Object.assign(dr(e), {
    displayName: (t = e.displayName) != null ? t : e.name
  });
}

function mr(e) {
  var t = Object.assign({}, e);

  for (var r in t) {
    t[r] === void 0 && delete t[r];
  }

  return t;
}

function gt(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var r = Object.assign({}, e);

  var _iterator5 = _createForOfIteratorHelper(t),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var o = _step5.value;
      o in r && delete r[o];
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return r;
}

function br(e) {
  throw new Error("Unexpected object: " + e);
}

function ae(e, t) {
  var r = t.resolveItems();
  if (r.length <= 0) return null;

  var o = t.resolveActiveIndex(),
      n = o != null ? o : -1,
      i = function () {
    switch (e.focus) {
      case 0:
        return r.findIndex(function (a) {
          return !t.resolveDisabled(a);
        });

      case 1:
        {
          var a = r.slice().reverse().findIndex(function (l, s, u) {
            return n !== -1 && u.length - s - 1 >= n ? !1 : !t.resolveDisabled(l);
          });
          return a === -1 ? a : r.length - 1 - a;
        }

      case 2:
        return r.findIndex(function (a, l) {
          return l <= n ? !1 : !t.resolveDisabled(a);
        });

      case 3:
        {
          var _a = r.slice().reverse().findIndex(function (l) {
            return !t.resolveDisabled(l);
          });

          return _a === -1 ? _a : r.length - 1 - _a;
        }

      case 4:
        return r.findIndex(function (a) {
          return t.resolveId(a) === e.id;
        });

      case 5:
        return null;

      default:
        br(e);
    }
  }();

  return i === -1 ? o : i;
}

function G(e) {
  var t = e.parentElement,
      r = null;

  for (; t && !(t instanceof HTMLFieldSetElement);) {
    t instanceof HTMLLegendElement && (r = t), t = t.parentElement;
  }

  var o = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return o && Tr(r) ? !1 : o;
}

function Tr(e) {
  if (!e) return !1;
  var t = e.previousElementSibling;

  for (; t !== null;) {
    if (t instanceof HTMLLegendElement) return !1;
    t = t.previousElementSibling;
  }

  return !0;
}

import { useEffect as yr, useRef as gr } from "react";

function w(e, t, r) {
  var o = gr(t);
  o.current = t, yr(function () {
    function n(i) {
      o.current.call(window, i);
    }

    return window.addEventListener(e, n, r), function () {
      return window.removeEventListener(e, n, r);
    };
  }, [e, r]);
}

import Pr, { createContext as xr, useContext as vr } from "react";
var Pt = xr(null);
Pt.displayName = "OpenClosedContext";

function _() {
  return vr(Pt);
}

function W(_ref3) {
  var e = _ref3.value,
      t = _ref3.children;
  return Pr.createElement(Pt.Provider, {
    value: e
  }, t);
}

import { useState as Rr } from "react";

function ro(e) {
  var r;
  if (e.type) return e.type;
  var t = (r = e.as) != null ? r : "button";
  if (typeof t == "string" && t.toLowerCase() === "button") return "button";
}

function U(e, t) {
  var _Rr = Rr(function () {
    return ro(e);
  }),
      _Rr2 = _slicedToArray(_Rr, 2),
      r = _Rr2[0],
      o = _Rr2[1];

  return x(function () {
    o(ro(e));
  }, [e.type, e.as]), x(function () {
    r || !t.current || t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && o("button");
  }, [r, t]), r;
}

import { useRef as no, useEffect as Er } from "react";

function se(_ref4) {
  var e = _ref4.container,
      t = _ref4.accept,
      r = _ref4.walk,
      _ref4$enabled = _ref4.enabled,
      o = _ref4$enabled === void 0 ? !0 : _ref4$enabled;
  var n = no(t),
      i = no(r);
  Er(function () {
    n.current = t, i.current = r;
  }, [t, r]), x(function () {
    if (!e || !o) return;
    var a = n.current,
        l = i.current,
        s = Object.assign(function (c) {
      return a(c);
    }, {
      acceptNode: a
    }),
        u = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, s, !1);

    for (; u.nextNode();) {
      l(u.currentNode);
    }
  }, [e, o, n, i]);
}

var Ar = (_Ar = {}, _defineProperty(_Ar, 1, function _(e) {
  return e.disabled || e.comboboxState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
    activeOptionIndex: null,
    comboboxState: 1
  });
}), _defineProperty(_Ar, 0, function _(e) {
  return e.disabled || e.comboboxState === 0 ? e : _objectSpread(_objectSpread({}, e), {}, {
    comboboxState: 0
  });
}), _defineProperty(_Ar, 2, function _(e, t) {
  return e.disabled === t.disabled ? e : _objectSpread(_objectSpread({}, e), {}, {
    disabled: t.disabled
  });
}), _defineProperty(_Ar, 3, function _(e, t) {
  if (e.disabled || e.optionsRef.current && !e.optionsPropsRef.current.static && e.comboboxState === 1) return e;
  var r = ae(t, {
    resolveItems: function resolveItems() {
      return e.options;
    },
    resolveActiveIndex: function resolveActiveIndex() {
      return e.activeOptionIndex;
    },
    resolveId: function resolveId(o) {
      return o.id;
    },
    resolveDisabled: function resolveDisabled(o) {
      return o.dataRef.current.disabled;
    }
  });
  return e.activeOptionIndex === r ? e : _objectSpread(_objectSpread({}, e), {}, {
    activeOptionIndex: r
  });
}), _defineProperty(_Ar, 4, function _(e, t) {
  var i;
  var r = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null,
      o = Array.from((i = e.optionsRef.current) == null ? void 0 : i.querySelectorAll('[id^="headlessui-combobox-option-"]')).reduce(function (a, l, s) {
    return Object.assign(a, _defineProperty({}, l.id, s));
  }, {}),
      n = [].concat(_toConsumableArray(e.options), [{
    id: t.id,
    dataRef: t.dataRef
  }]).sort(function (a, l) {
    return o[a.id] - o[l.id];
  });
  return _objectSpread(_objectSpread({}, e), {}, {
    options: n,
    activeOptionIndex: function () {
      return r === null ? null : n.indexOf(r);
    }()
  });
}), _defineProperty(_Ar, 5, function _(e, t) {
  var r = e.options.slice(),
      o = e.activeOptionIndex !== null ? r[e.activeOptionIndex] : null,
      n = r.findIndex(function (i) {
    return i.id === t.id;
  });
  return n !== -1 && r.splice(n, 1), _objectSpread(_objectSpread({}, e), {}, {
    options: r,
    activeOptionIndex: function () {
      return n === e.activeOptionIndex || o === null ? null : r.indexOf(o);
    }()
  });
}), _Ar),
    vt = lo(null);
vt.displayName = "ComboboxContext";

function pe(e) {
  var t = ao(vt);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <Combobox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, pe), r;
  }

  return t;
}

var Rt = lo(null);
Rt.displayName = "ComboboxActions";

function Ue() {
  var e = ao(Rt);

  if (e === null) {
    var t = new Error("ComboboxActions is missing a parent <Combobox /> component.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, Ue), t;
  }

  return e;
}

function hr(e, t) {
  return S(t.type, Ar, e, t);
}

var Or = Cr,
    Ir = D(function (t, r) {
  var _S2;

  var o = t.value,
      n = t.onChange,
      _t$disabled = t.disabled,
      i = _t$disabled === void 0 ? !1 : _t$disabled,
      a = _objectWithoutProperties(t, _excluded4),
      l = He({
    value: o,
    onChange: n
  }),
      s = He({
    static: !1,
    hold: !1
  }),
      u = He({
    displayValue: void 0
  }),
      c = Sr(hr, {
    comboboxState: 1,
    comboboxPropsRef: l,
    optionsPropsRef: s,
    inputPropsRef: u,
    labelRef: Ge(),
    inputRef: Ge(),
    buttonRef: Ge(),
    optionsRef: Ge(),
    disabled: i,
    options: [],
    activeOptionIndex: null
  }),
      _c = _slicedToArray(c, 2),
      _c$ = _c[0],
      m = _c$.comboboxState,
      b = _c$.options,
      T = _c$.activeOptionIndex,
      y = _c$.optionsRef,
      p = _c$.inputRef,
      f = _c$.buttonRef,
      d = _c[1];

  x(function () {
    l.current.value = o;
  }, [o, l]), x(function () {
    l.current.onChange = n;
  }, [n, l]), x(function () {
    return d({
      type: 2,
      disabled: i
    });
  }, [i]), w("mousedown", function (O) {
    var N, K, V;
    var L = O.target;
    m === 0 && (((N = f.current) == null ? void 0 : N.contains(L)) || ((K = p.current) == null ? void 0 : K.contains(L)) || ((V = y.current) == null ? void 0 : V.contains(L)) || d({
      type: 1
    }));
  });
  var P = T === null ? null : b[T].dataRef.current.value,
      C = oe(function () {
    return {
      open: m === 0,
      disabled: i,
      activeIndex: T,
      activeOption: P
    };
  }, [m, i, b, T]),
      R = B(function () {
    if (!p.current || o === void 0) return;
    var O = u.current.displayValue;
    typeof O == "function" ? p.current.value = O(o) : typeof o == "string" && (p.current.value = o);
  }, [o, p, u]),
      g = B(function (O) {
    var L = b.find(function (K) {
      return K.id === O;
    });
    if (!L) return;
    var N = L.dataRef;
    l.current.onChange(N.current.value), R();
  }, [b, l, p]),
      v = B(function () {
    if (T !== null) {
      var O = b[T].dataRef;
      l.current.onChange(O.current.value), R();
    }
  }, [T, b, l, p]),
      h = oe(function () {
    return {
      selectOption: g,
      selectActiveOption: v
    };
  }, [g, v]);
  return x(function () {
    m === 1 && R();
  }, [R, m]), x(R, [R]), xt.createElement(Rt.Provider, {
    value: h
  }, xt.createElement(vt.Provider, {
    value: c
  }, xt.createElement(W, {
    value: S(m, (_S2 = {}, _defineProperty(_S2, 0, 0), _defineProperty(_S2, 1, 1), _S2))
  }, E({
    props: r === null ? a : _objectSpread(_objectSpread({}, a), {}, {
      ref: r
    }),
    slot: C,
    defaultTag: Or,
    name: "Combobox"
  }))));
}),
    Lr = "input",
    Dr = D(function (t, r) {
  var R, g;

  var o = t.value,
      n = t.onChange,
      i = t.displayValue,
      a = _objectWithoutProperties(t, _excluded5),
      _pe = pe("Combobox.Input"),
      _pe2 = _slicedToArray(_pe, 2),
      l = _pe2[0],
      s = _pe2[1],
      u = Ue(),
      c = I(l.inputRef, r),
      m = l.inputPropsRef,
      b = "headlessui-combobox-input-".concat(A()),
      T = Q(),
      y = ke(n);

  x(function () {
    m.current.displayValue = i;
  }, [i, m]);
  var p = B(function (v) {
    var _S3, _S4;

    switch (v.key) {
      case "Enter":
        v.preventDefault(), v.stopPropagation(), u.selectActiveOption(), s({
          type: 1
        });
        break;

      case "ArrowDown":
        return v.preventDefault(), v.stopPropagation(), S(l.comboboxState, (_S3 = {}, _defineProperty(_S3, 0, function _() {
          return s({
            type: 3,
            focus: 2
          });
        }), _defineProperty(_S3, 1, function _() {
          s({
            type: 0
          }), T.nextFrame(function () {
            l.comboboxPropsRef.current.value || s({
              type: 3,
              focus: 0
            });
          });
        }), _S3));

      case "ArrowUp":
        return v.preventDefault(), v.stopPropagation(), S(l.comboboxState, (_S4 = {}, _defineProperty(_S4, 0, function _() {
          return s({
            type: 3,
            focus: 1
          });
        }), _defineProperty(_S4, 1, function _() {
          s({
            type: 0
          }), T.nextFrame(function () {
            l.comboboxPropsRef.current.value || s({
              type: 3,
              focus: 3
            });
          });
        }), _S4));

      case "Home":
      case "PageUp":
        return v.preventDefault(), v.stopPropagation(), s({
          type: 3,
          focus: 0
        });

      case "End":
      case "PageDown":
        return v.preventDefault(), v.stopPropagation(), s({
          type: 3,
          focus: 3
        });

      case "Escape":
        return v.preventDefault(), l.optionsRef.current && !l.optionsPropsRef.current.static && v.stopPropagation(), s({
          type: 1
        });

      case "Tab":
        u.selectActiveOption(), s({
          type: 1
        });
        break;
    }
  }, [T, s, l, u]),
      f = B(function (v) {
    var h;
    s({
      type: 0
    }), (h = y.current) == null || h.call(y, v);
  }, [s, y]),
      d = ee(function () {
    if (!!l.labelRef.current) return [l.labelRef.current.id].join(" ");
  }, [l.labelRef.current]),
      P = oe(function () {
    return {
      open: l.comboboxState === 0,
      disabled: l.disabled
    };
  }, [l]),
      C = {
    ref: c,
    id: b,
    role: "combobox",
    type: "text",
    "aria-controls": (R = l.optionsRef.current) == null ? void 0 : R.id,
    "aria-expanded": l.disabled ? void 0 : l.comboboxState === 0,
    "aria-activedescendant": l.activeOptionIndex === null || (g = l.options[l.activeOptionIndex]) == null ? void 0 : g.id,
    "aria-labelledby": d,
    disabled: l.disabled,
    onKeyDown: p,
    onChange: f
  };
  return E({
    props: _objectSpread(_objectSpread({}, a), C),
    slot: P,
    defaultTag: Lr,
    name: "Combobox.Input"
  });
}),
    Mr = "button",
    Fr = D(function (t, r) {
  var p;

  var _pe3 = pe("Combobox.Button"),
      _pe4 = _slicedToArray(_pe3, 2),
      o = _pe4[0],
      n = _pe4[1],
      i = Ue(),
      a = I(o.buttonRef, r),
      l = "headlessui-combobox-button-".concat(A()),
      s = Q(),
      u = B(function (f) {
    switch (f.key) {
      case "ArrowDown":
        return f.preventDefault(), f.stopPropagation(), o.comboboxState === 1 && (n({
          type: 0
        }), s.nextFrame(function () {
          o.comboboxPropsRef.current.value || n({
            type: 3,
            focus: 0
          });
        })), s.nextFrame(function () {
          var d;
          return (d = o.inputRef.current) == null ? void 0 : d.focus({
            preventScroll: !0
          });
        });

      case "ArrowUp":
        return f.preventDefault(), f.stopPropagation(), o.comboboxState === 1 && (n({
          type: 0
        }), s.nextFrame(function () {
          o.comboboxPropsRef.current.value || n({
            type: 3,
            focus: 3
          });
        })), s.nextFrame(function () {
          var d;
          return (d = o.inputRef.current) == null ? void 0 : d.focus({
            preventScroll: !0
          });
        });

      case "Escape":
        return f.preventDefault(), o.optionsRef.current && !o.optionsPropsRef.current.static && f.stopPropagation(), n({
          type: 1
        }), s.nextFrame(function () {
          var d;
          return (d = o.inputRef.current) == null ? void 0 : d.focus({
            preventScroll: !0
          });
        });
    }
  }, [s, n, o, i]),
      c = B(function (f) {
    if (G(f.currentTarget)) return f.preventDefault();
    o.comboboxState === 0 ? n({
      type: 1
    }) : (f.preventDefault(), n({
      type: 0
    })), s.nextFrame(function () {
      var d;
      return (d = o.inputRef.current) == null ? void 0 : d.focus({
        preventScroll: !0
      });
    });
  }, [n, s, o]),
      m = ee(function () {
    if (!!o.labelRef.current) return [o.labelRef.current.id, l].join(" ");
  }, [o.labelRef.current, l]),
      b = oe(function () {
    return {
      open: o.comboboxState === 0,
      disabled: o.disabled
    };
  }, [o]),
      T = t,
      y = {
    ref: a,
    id: l,
    type: U(t, o.buttonRef),
    tabIndex: -1,
    "aria-haspopup": !0,
    "aria-controls": (p = o.optionsRef.current) == null ? void 0 : p.id,
    "aria-expanded": o.disabled ? void 0 : o.comboboxState === 0,
    "aria-labelledby": m,
    disabled: o.disabled,
    onClick: c,
    onKeyDown: u
  };

  return E({
    props: _objectSpread(_objectSpread({}, T), y),
    slot: b,
    defaultTag: Mr,
    name: "Combobox.Button"
  });
}),
    wr = "label";

function kr(e) {
  var _pe5 = pe("Combobox.Label"),
      _pe6 = _slicedToArray(_pe5, 1),
      t = _pe6[0],
      r = "headlessui-combobox-label-".concat(A()),
      o = B(function () {
    var a;
    return (a = t.inputRef.current) == null ? void 0 : a.focus({
      preventScroll: !0
    });
  }, [t.inputRef]),
      n = oe(function () {
    return {
      open: t.comboboxState === 0,
      disabled: t.disabled
    };
  }, [t]),
      i = {
    ref: t.labelRef,
    id: r,
    onClick: o
  };

  return E({
    props: _objectSpread(_objectSpread({}, e), i),
    slot: n,
    defaultTag: wr,
    name: "Combobox.Label"
  });
}

var _r = "ul",
    Gr = 1 | 2,
    Hr = D(function (t, r) {
  var y;

  var _t$hold = t.hold,
      o = _t$hold === void 0 ? !1 : _t$hold,
      n = _objectWithoutProperties(t, _excluded6),
      _pe7 = pe("Combobox.Options"),
      _pe8 = _slicedToArray(_pe7, 1),
      i = _pe8[0],
      a = i.optionsPropsRef,
      l = I(i.optionsRef, r),
      s = "headlessui-combobox-options-".concat(A()),
      u = _(),
      c = function () {
    return u !== null ? u === 0 : i.comboboxState === 0;
  }();

  x(function () {
    var p;
    a.current.static = (p = t.static) != null ? p : !1;
  }, [a, t.static]), x(function () {
    a.current.hold = o;
  }, [o, a]), se({
    container: i.optionsRef.current,
    enabled: i.comboboxState === 0,
    accept: function accept(p) {
      return p.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : p.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(p) {
      p.setAttribute("role", "none");
    }
  });
  var m = ee(function () {
    var p, f, d;
    return (d = (p = i.labelRef.current) == null ? void 0 : p.id) != null ? d : (f = i.buttonRef.current) == null ? void 0 : f.id;
  }, [i.labelRef.current, i.buttonRef.current]),
      b = oe(function () {
    return {
      open: i.comboboxState === 0
    };
  }, [i]),
      T = {
    "aria-activedescendant": i.activeOptionIndex === null || (y = i.options[i.activeOptionIndex]) == null ? void 0 : y.id,
    "aria-labelledby": m,
    role: "listbox",
    id: s,
    ref: l
  };
  return E({
    props: _objectSpread(_objectSpread({}, n), T),
    slot: b,
    defaultTag: _r,
    features: Gr,
    visible: c,
    name: "Combobox.Options"
  });
}),
    Ur = "li";

function Br(e) {
  var _e$disabled = e.disabled,
      t = _e$disabled === void 0 ? !1 : _e$disabled,
      r = e.value,
      o = _objectWithoutProperties(e, _excluded7),
      _pe9 = pe("Combobox.Option"),
      _pe10 = _slicedToArray(_pe9, 2),
      n = _pe10[0],
      i = _pe10[1],
      a = Ue(),
      l = "headlessui-combobox-option-".concat(A()),
      s = n.activeOptionIndex !== null ? n.options[n.activeOptionIndex].id === l : !1,
      u = n.comboboxPropsRef.current.value === r,
      c = He({
    disabled: t,
    value: r
  });

  x(function () {
    c.current.disabled = t;
  }, [c, t]), x(function () {
    c.current.value = r;
  }, [c, r]), x(function () {
    var P, C;
    c.current.textValue = (C = (P = document.getElementById(l)) == null ? void 0 : P.textContent) == null ? void 0 : C.toLowerCase();
  }, [c, l]);
  var m = B(function () {
    return a.selectOption(l);
  }, [a, l]);
  x(function () {
    return i({
      type: 4,
      id: l,
      dataRef: c
    }), function () {
      return i({
        type: 5,
        id: l
      });
    };
  }, [c, l]), x(function () {
    n.comboboxState === 0 && (!u || i({
      type: 3,
      focus: 4,
      id: l
    }));
  }, [n.comboboxState, u, l]), x(function () {
    if (n.comboboxState !== 0 || !s) return;
    var P = k();
    return P.requestAnimationFrame(function () {
      var C, R;
      (R = (C = document.getElementById(l)) == null ? void 0 : C.scrollIntoView) == null || R.call(C, {
        block: "nearest"
      });
    }), P.dispose;
  }, [l, s, n.comboboxState, n.activeOptionIndex]);
  var b = B(function (P) {
    if (t) return P.preventDefault();
    m(), i({
      type: 1
    }), k().nextFrame(function () {
      var C;
      return (C = n.inputRef.current) == null ? void 0 : C.focus({
        preventScroll: !0
      });
    });
  }, [i, n.inputRef, t, m]),
      T = B(function () {
    if (t) return i({
      type: 3,
      focus: 5
    });
    i({
      type: 3,
      focus: 4,
      id: l
    });
  }, [t, l, i]),
      y = B(function () {
    t || s || i({
      type: 3,
      focus: 4,
      id: l
    });
  }, [t, s, l, i]),
      p = B(function () {
    t || !s || n.optionsPropsRef.current.hold || i({
      type: 3,
      focus: 5
    });
  }, [t, s, i, n.comboboxState, n.comboboxPropsRef]),
      f = oe(function () {
    return {
      active: s,
      selected: u,
      disabled: t
    };
  }, [s, u, t]);
  return E({
    props: _objectSpread(_objectSpread({}, o), {
      id: l,
      role: "option",
      tabIndex: t === !0 ? void 0 : -1,
      "aria-disabled": t === !0 ? !0 : void 0,
      "aria-selected": u === !0 ? !0 : void 0,
      disabled: void 0,
      onClick: b,
      onFocus: T,
      onPointerMove: y,
      onMouseMove: y,
      onPointerLeave: p,
      onMouseLeave: p
    }),
    slot: f,
    defaultTag: Ur,
    name: "Combobox.Option"
  });
}

var Na = Object.assign(Ir, {
  Input: Dr,
  Button: Fr,
  Label: kr,
  Options: Hr,
  Option: Br
});
import ne, { createContext as mn, useCallback as Ke, useContext as Co, useEffect as Ot, useMemo as je, useReducer as bn, useRef as So, useState as Tn } from "react";
import { useRef as uo, useEffect as St } from "react";
var Et = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map(function (e) {
  return "".concat(e, ":not([tabindex='-1'])");
}).join(",");

function xe() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  return e == null ? [] : Array.from(e.querySelectorAll(Et));
}

function de(e) {
  var _S5;

  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return e === document.body ? !1 : S(t, (_S5 = {}, _defineProperty(_S5, 0, function _() {
    return e.matches(Et);
  }), _defineProperty(_S5, 1, function _() {
    var r = e;

    for (; r !== null;) {
      if (r.matches(Et)) return !0;
      r = r.parentElement;
    }

    return !1;
  }), _S5));
}

function ce(e) {
  e == null || e.focus({
    preventScroll: !0
  });
}

function M(e, t) {
  var r = Array.isArray(e) ? e.slice().sort(function (c, m) {
    var b = c.compareDocumentPosition(m);
    return b & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : b & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  }) : xe(e),
      o = document.activeElement,
      n = function () {
    if (t & (1 | 4)) return 1;
    if (t & (2 | 8)) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  }(),
      i = function () {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, r.indexOf(o)) - 1;
    if (t & 4) return Math.max(0, r.indexOf(o)) + 1;
    if (t & 8) return r.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  }(),
      a = t & 32 ? {
    preventScroll: !0
  } : {},
      l = 0,
      s = r.length,
      u;

  do {
    if (l >= s || l + s <= 0) return 0;
    var c = i + l;
    if (t & 16) c = (c + s) % s;else {
      if (c < 0) return 3;
      if (c >= s) return 1;
    }
    u = r[c], u == null || u.focus(a), l += n;
  } while (u !== document.activeElement);

  return u.hasAttribute("tabindex") || u.setAttribute("tabindex", "0"), 2;
}

import { useRef as Nr, useEffect as Wr } from "react";

function Be() {
  var e = Nr(!1);
  return Wr(function () {
    return e.current = !0, function () {
      e.current = !1;
    };
  }, []), e;
}

function Ne(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;

  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      r = _ref5.initialFocus,
      o = _ref5.containers;

  var n = uo(typeof window != "undefined" ? document.activeElement : null),
      i = uo(null),
      a = Be(),
      l = Boolean(t & 16),
      s = Boolean(t & 2);
  St(function () {
    !l || (n.current = document.activeElement);
  }, [l]), St(function () {
    if (!!l) return function () {
      ce(n.current), n.current = null;
    };
  }, [l]), St(function () {
    if (!s || !e.current) return;
    var u = document.activeElement;

    if (r == null ? void 0 : r.current) {
      if ((r == null ? void 0 : r.current) === u) {
        i.current = u;
        return;
      }
    } else if (e.current.contains(u)) {
      i.current = u;
      return;
    }

    (r == null ? void 0 : r.current) ? ce(r.current) : M(e.current, 1) === 0 && console.warn("There are no focusable elements inside the <FocusTrap />"), i.current = document.activeElement;
  }, [e, r, s]), w("keydown", function (u) {
    !(t & 4) || !e.current || u.key === "Tab" && (u.preventDefault(), M(e.current, (u.shiftKey ? 2 : 4) | 16) === 2 && (i.current = document.activeElement));
  }), w("focus", function (u) {
    if (!(t & 8)) return;
    var c = new Set(o == null ? void 0 : o.current);
    if (c.add(e), !c.size) return;
    var m = i.current;
    if (!m || !a.current) return;
    var b = u.target;
    b && b instanceof HTMLElement ? Kr(c, b) ? (i.current = b, ce(b)) : (u.preventDefault(), u.stopPropagation(), ce(m)) : ce(i.current);
  }, !0);
}

function Kr(e, t) {
  var r;

  var _iterator6 = _createForOfIteratorHelper(e),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var o = _step6.value;
      if ((r = o.current) == null ? void 0 : r.contains(t)) return !0;
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return !1;
}

var fe = new Set(),
    J = new Map();

function po(e) {
  e.setAttribute("aria-hidden", "true"), e.inert = !0;
}

function co(e) {
  var t = J.get(e);
  !t || (t["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", t["aria-hidden"]), e.inert = t.inert);
}

function fo(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  x(function () {
    if (!t || !e.current) return;
    var r = e.current;
    fe.add(r);

    var _iterator7 = _createForOfIteratorHelper(J.keys()),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var o = _step7.value;
        o.contains(r) && (co(o), J.delete(o));
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }

    return document.querySelectorAll("body > *").forEach(function (o) {
      if (o instanceof HTMLElement) {
        var _iterator8 = _createForOfIteratorHelper(fe),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var n = _step8.value;
            if (o.contains(n)) return;
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        fe.size === 1 && (J.set(o, {
          "aria-hidden": o.getAttribute("aria-hidden"),
          inert: o.inert
        }), po(o));
      }
    }), function () {
      if (fe.delete(r), fe.size > 0) document.querySelectorAll("body > *").forEach(function (o) {
        if (o instanceof HTMLElement && !J.has(o)) {
          var _iterator9 = _createForOfIteratorHelper(fe),
              _step9;

          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var n = _step9.value;
              if (o.contains(n)) return;
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }

          J.set(o, {
            "aria-hidden": o.getAttribute("aria-hidden"),
            inert: o.inert
          }), po(o);
        }
      });else {
        var _iterator10 = _createForOfIteratorHelper(J.keys()),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var o = _step10.value;
            co(o), J.delete(o);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
    };
  }, [t]);
}

import Qr, { Fragment as To, createContext as qr, useContext as zr, useEffect as yo, useState as go } from "react";
import { createPortal as Yr } from "react-dom";
import jr, { createContext as Vr, useContext as $r } from "react";
var mo = Vr(!1);

function bo() {
  return $r(mo);
}

function At(e) {
  return jr.createElement(mo.Provider, {
    value: e.force
  }, e.children);
}

function Xr() {
  var e = bo(),
      t = zr(Po),
      _go = go(function () {
    if (!e && t !== null || typeof window == "undefined") return null;
    var n = document.getElementById("headlessui-portal-root");
    if (n) return n;
    var i = document.createElement("div");
    return i.setAttribute("id", "headlessui-portal-root"), document.body.appendChild(i);
  }),
      _go2 = _slicedToArray(_go, 2),
      r = _go2[0],
      o = _go2[1];

  return yo(function () {
    r !== null && (document.body.contains(r) || document.body.appendChild(r));
  }, [r]), yo(function () {
    e || t !== null && o(t.current);
  }, [t, o, e]), r;
}

var Jr = To;

function We(e) {
  var t = e,
      r = Xr(),
      _go3 = go(function () {
    return typeof window == "undefined" ? null : document.createElement("div");
  }),
      _go4 = _slicedToArray(_go3, 1),
      o = _go4[0],
      n = q();

  return x(function () {
    if (!!r && !!o) return r.appendChild(o), function () {
      var i;
      !r || !o || (r.removeChild(o), r.childNodes.length <= 0 && ((i = r.parentElement) == null || i.removeChild(r)));
    };
  }, [r, o]), n ? !r || !o ? null : Yr(E({
    props: t,
    defaultTag: Jr,
    name: "Portal"
  }), o) : null;
}

var Zr = To,
    Po = qr(null);

function en(e) {
  var t = e.target,
      r = _objectWithoutProperties(e, _excluded8);

  return Qr.createElement(Po.Provider, {
    value: t
  }, E({
    props: r,
    defaultTag: Zr,
    name: "Popover.Group"
  }));
}

We.Group = en;
import tn, { createContext as on, useCallback as rn, useContext as nn, useMemo as xo, useState as ln } from "react";
var vo = on(null);

function Ro() {
  var e = nn(vo);

  if (e === null) {
    var t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, Ro), t;
  }

  return e;
}

function re() {
  var _ln = ln([]),
      _ln2 = _slicedToArray(_ln, 2),
      e = _ln2[0],
      t = _ln2[1];

  return [e.length > 0 ? e.join(" ") : void 0, xo(function () {
    return function (o) {
      var n = rn(function (a) {
        return t(function (l) {
          return [].concat(_toConsumableArray(l), [a]);
        }), function () {
          return t(function (l) {
            var s = l.slice(),
                u = s.indexOf(a);
            return u !== -1 && s.splice(u, 1), s;
          });
        };
      }, []),
          i = xo(function () {
        return {
          register: n,
          slot: o.slot,
          name: o.name,
          props: o.props
        };
      }, [n, o.slot, o.name, o.props]);
      return tn.createElement(vo.Provider, {
        value: i
      }, o.children);
    };
  }, [t])];
}

var an = "p";

function me(e) {
  var t = Ro(),
      r = "headlessui-description-".concat(A());
  x(function () {
    return t.register(r);
  }, [r, t.register]);

  var o = e,
      n = _objectSpread(_objectSpread({}, t.props), {}, {
    id: r
  });

  return E({
    props: _objectSpread(_objectSpread({}, o), n),
    slot: t.slot || {},
    defaultTag: an,
    name: t.name || "Description"
  });
}

import sn, { createContext as un, useCallback as pn, useContext as dn } from "react";
var ht = un(function () {});
ht.displayName = "StackContext";

function cn() {
  return dn(ht);
}

function Eo(_ref6) {
  var e = _ref6.children,
      t = _ref6.onUpdate,
      r = _ref6.type,
      o = _ref6.element;
  var n = cn(),
      i = pn(function () {
    t == null || t.apply(void 0, arguments), n.apply(void 0, arguments);
  }, [n, t]);
  return x(function () {
    return i(0, r, o), function () {
      return i(1, r, o);
    };
  }, [i, r, o]), sn.createElement(ht.Provider, {
    value: i
  }, e);
}

var yn = _defineProperty({}, 0, function _(e, t) {
  return e.titleId === t.id ? e : _objectSpread(_objectSpread({}, e), {}, {
    titleId: t.id
  });
}),
    Ve = mn(null);

Ve.displayName = "DialogContext";

function It(e) {
  var t = Co(Ve);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <").concat(An.displayName, " /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, It), r;
  }

  return t;
}

function gn(e, t) {
  return S(t.type, yn, e, t);
}

var Pn = "div",
    xn = 1 | 2,
    vn = D(function (t, r) {
  var _S6;

  var o = t.open,
      n = t.onClose,
      i = t.initialFocus,
      a = _objectWithoutProperties(t, _excluded9),
      _Tn = Tn(0),
      _Tn2 = _slicedToArray(_Tn, 2),
      l = _Tn2[0],
      s = _Tn2[1],
      u = _();

  o === void 0 && u !== null && (o = S(u, (_S6 = {}, _defineProperty(_S6, 0, !0), _defineProperty(_S6, 1, !1), _S6)));
  var c = So(new Set()),
      m = So(null),
      b = I(m, r),
      T = t.hasOwnProperty("open") || u !== null,
      y = t.hasOwnProperty("onClose");
  if (!T && !y) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!T) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!y) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof o != "boolean") throw new Error("You provided an `open` prop to the `Dialog`, but the value is not a boolean. Received: ".concat(o));
  if (typeof n != "function") throw new Error("You provided an `onClose` prop to the `Dialog`, but the value is not a function. Received: ".concat(n));

  var p = o ? 0 : 1,
      f = function () {
    return u !== null ? u === 0 : p === 0;
  }(),
      _bn = bn(gn, {
    titleId: null,
    descriptionId: null
  }),
      _bn2 = _slicedToArray(_bn, 2),
      d = _bn2[0],
      P = _bn2[1],
      C = Ke(function () {
    return n(!1);
  }, [n]),
      R = Ke(function (F) {
    return P({
      type: 0,
      id: F
    });
  }, [P]),
      v = q() && p === 0,
      h = l > 1,
      O = Co(Ve) !== null;

  Ne(m, v ? S(h ? "parent" : "leaf", {
    parent: 16,
    leaf: 30
  }) : 1, {
    initialFocus: i,
    containers: c
  }), fo(m, h ? v : !1), w("mousedown", function (F) {
    var H;
    var $ = F.target;
    p === 0 && (h || ((H = m.current) == null ? void 0 : H.contains($)) || C());
  }), w("keydown", function (F) {
    F.key === "Escape" && p === 0 && (h || (F.preventDefault(), F.stopPropagation(), C()));
  }), Ot(function () {
    if (p !== 0 || O) return;
    var F = document.documentElement.style.overflow,
        $ = document.documentElement.style.paddingRight,
        H = window.innerWidth - document.documentElement.clientWidth;
    return document.documentElement.style.overflow = "hidden", document.documentElement.style.paddingRight = "".concat(H, "px"), function () {
      document.documentElement.style.overflow = F, document.documentElement.style.paddingRight = $;
    };
  }, [p, O]), Ot(function () {
    if (p !== 0 || !m.current) return;
    var F = new IntersectionObserver(function ($) {
      var _iterator11 = _createForOfIteratorHelper($),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var H = _step11.value;
          H.boundingClientRect.x === 0 && H.boundingClientRect.y === 0 && H.boundingClientRect.width === 0 && H.boundingClientRect.height === 0 && C();
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
    });
    return F.observe(m.current), function () {
      return F.disconnect();
    };
  }, [p, m, C]);

  var _re = re(),
      _re2 = _slicedToArray(_re, 2),
      N = _re2[0],
      K = _re2[1],
      V = "headlessui-dialog-".concat(A()),
      Fe = je(function () {
    return [{
      dialogState: p,
      close: C,
      setTitleId: R
    }, d];
  }, [p, d, C, R]),
      ge = je(function () {
    return {
      open: p === 0
    };
  }, [p]),
      we = {
    ref: b,
    id: V,
    role: "dialog",
    "aria-modal": p === 0 ? !0 : void 0,
    "aria-labelledby": d.titleId,
    "aria-describedby": N,
    onClick: function onClick(F) {
      F.stopPropagation();
    }
  },
      X = a;

  return ne.createElement(Eo, {
    type: "Dialog",
    element: m,
    onUpdate: Ke(function (F, $, H) {
      var _S7;

      $ === "Dialog" && S(F, (_S7 = {}, _defineProperty(_S7, 0, function _() {
        c.current.add(H), s(function (Pe) {
          return Pe + 1;
        });
      }), _defineProperty(_S7, 1, function _() {
        c.current.add(H), s(function (Pe) {
          return Pe - 1;
        });
      }), _S7));
    }, [])
  }, ne.createElement(At, {
    force: !0
  }, ne.createElement(We, null, ne.createElement(Ve.Provider, {
    value: Fe
  }, ne.createElement(We.Group, {
    target: m
  }, ne.createElement(At, {
    force: !1
  }, ne.createElement(K, {
    slot: ge,
    name: "Dialog.Description"
  }, E({
    props: _objectSpread(_objectSpread({}, X), we),
    slot: ge,
    defaultTag: Pn,
    features: xn,
    visible: f,
    name: "Dialog"
  }))))))));
}),
    Rn = "div",
    En = D(function (t, r) {
  var _It = It("Dialog.Overlay"),
      _It2 = _slicedToArray(_It, 1),
      _It2$ = _It2[0],
      o = _It2$.dialogState,
      n = _It2$.close,
      i = I(r),
      a = "headlessui-dialog-overlay-".concat(A()),
      l = Ke(function (m) {
    if (m.target === m.currentTarget) {
      if (G(m.currentTarget)) return m.preventDefault();
      m.preventDefault(), m.stopPropagation(), n();
    }
  }, [n]),
      s = je(function () {
    return {
      open: o === 0
    };
  }, [o]);

  return E({
    props: _objectSpread(_objectSpread({}, t), {
      ref: i,
      id: a,
      "aria-hidden": !0,
      onClick: l
    }),
    slot: s,
    defaultTag: Rn,
    name: "Dialog.Overlay"
  });
}),
    Cn = "h2";

function Sn(e) {
  var _It3 = It("Dialog.Title"),
      _It4 = _slicedToArray(_It3, 1),
      _It4$ = _It4[0],
      t = _It4$.dialogState,
      r = _It4$.setTitleId,
      o = "headlessui-dialog-title-".concat(A());

  Ot(function () {
    return r(o), function () {
      return r(null);
    };
  }, [o, r]);
  var n = je(function () {
    return {
      open: t === 0
    };
  }, [t]);
  return E({
    props: _objectSpread(_objectSpread({}, e), {
      id: o
    }),
    slot: n,
    defaultTag: Cn,
    name: "Dialog.Title"
  });
}

var An = Object.assign(vn, {
  Overlay: En,
  Title: Sn,
  Description: me
});
import $e, { Fragment as hn, createContext as Lt, useCallback as Qe, useContext as Dt, useEffect as qe, useMemo as ze, useReducer as On, useRef as In } from "react";
var Ln = (_Ln = {}, _defineProperty(_Ln, 0, function _(e) {
  var _S8;

  return _objectSpread(_objectSpread({}, e), {}, {
    disclosureState: S(e.disclosureState, (_S8 = {}, _defineProperty(_S8, 0, 1), _defineProperty(_S8, 1, 0), _S8))
  });
}), _defineProperty(_Ln, 1, function _(e) {
  return e.disclosureState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
    disclosureState: 1
  });
}), _defineProperty(_Ln, 4, function _(e) {
  return e.linkedPanel === !0 ? e : _objectSpread(_objectSpread({}, e), {}, {
    linkedPanel: !0
  });
}), _defineProperty(_Ln, 5, function _(e) {
  return e.linkedPanel === !1 ? e : _objectSpread(_objectSpread({}, e), {}, {
    linkedPanel: !1
  });
}), _defineProperty(_Ln, 2, function _(e, t) {
  return e.buttonId === t.buttonId ? e : _objectSpread(_objectSpread({}, e), {}, {
    buttonId: t.buttonId
  });
}), _defineProperty(_Ln, 3, function _(e, t) {
  return e.panelId === t.panelId ? e : _objectSpread(_objectSpread({}, e), {}, {
    panelId: t.panelId
  });
}), _Ln),
    Mt = Lt(null);
Mt.displayName = "DisclosureContext";

function Ft(e) {
  var t = Dt(Mt);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <").concat(Ye.name, " /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, Ft), r;
  }

  return t;
}

var wt = Lt(null);
wt.displayName = "DisclosureAPIContext";

function Ao(e) {
  var t = Dt(wt);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <").concat(Ye.name, " /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, Ao), r;
  }

  return t;
}

var kt = Lt(null);
kt.displayName = "DisclosurePanelContext";

function Dn() {
  return Dt(kt);
}

function Mn(e, t) {
  return S(t.type, Ln, e, t);
}

var Fn = hn;

function Ye(e) {
  var _S9;

  var _e$defaultOpen = e.defaultOpen,
      t = _e$defaultOpen === void 0 ? !1 : _e$defaultOpen,
      r = _objectWithoutProperties(e, _excluded10),
      o = "headlessui-disclosure-button-".concat(A()),
      n = "headlessui-disclosure-panel-".concat(A()),
      i = On(Mn, {
    disclosureState: t ? 0 : 1,
    linkedPanel: !1,
    buttonId: o,
    panelId: n
  }),
      _i2 = _slicedToArray(i, 2),
      a = _i2[0].disclosureState,
      l = _i2[1];

  qe(function () {
    return l({
      type: 2,
      buttonId: o
    });
  }, [o, l]), qe(function () {
    return l({
      type: 3,
      panelId: n
    });
  }, [n, l]);
  var s = Qe(function (m) {
    l({
      type: 1
    });

    var b = function () {
      return m ? m instanceof HTMLElement ? m : m.current instanceof HTMLElement ? m.current : document.getElementById(o) : document.getElementById(o);
    }();

    b == null || b.focus();
  }, [l, o]),
      u = ze(function () {
    return {
      close: s
    };
  }, [s]),
      c = ze(function () {
    return {
      open: a === 0,
      close: s
    };
  }, [a, s]);
  return $e.createElement(Mt.Provider, {
    value: i
  }, $e.createElement(wt.Provider, {
    value: u
  }, $e.createElement(W, {
    value: S(a, (_S9 = {}, _defineProperty(_S9, 0, 0), _defineProperty(_S9, 1, 1), _S9))
  }, E({
    props: r,
    slot: c,
    defaultTag: Fn,
    name: "Disclosure"
  }))));
}

var wn = "button",
    kn = D(function (t, r) {
  var _Ft = Ft("Disclosure.Button"),
      _Ft2 = _slicedToArray(_Ft, 2),
      o = _Ft2[0],
      n = _Ft2[1],
      i = In(null),
      a = I(i, r),
      l = Dn(),
      s = l === null ? !1 : l === o.panelId,
      u = Qe(function (f) {
    var d;

    if (s) {
      if (o.disclosureState === 1) return;

      switch (f.key) {
        case " ":
        case "Enter":
          f.preventDefault(), f.stopPropagation(), n({
            type: 0
          }), (d = document.getElementById(o.buttonId)) == null || d.focus();
          break;
      }
    } else switch (f.key) {
      case " ":
      case "Enter":
        f.preventDefault(), f.stopPropagation(), n({
          type: 0
        });
        break;
    }
  }, [n, s, o.disclosureState, o.buttonId]),
      c = Qe(function (f) {
    switch (f.key) {
      case " ":
        f.preventDefault();
        break;
    }
  }, []),
      m = Qe(function (f) {
    var d;
    G(f.currentTarget) || t.disabled || (s ? (n({
      type: 0
    }), (d = document.getElementById(o.buttonId)) == null || d.focus()) : n({
      type: 0
    }));
  }, [n, t.disabled, o.buttonId, s]),
      b = ze(function () {
    return {
      open: o.disclosureState === 0
    };
  }, [o]),
      T = U(t, i),
      y = t,
      p = s ? {
    ref: a,
    type: T,
    onKeyDown: u,
    onClick: m
  } : {
    ref: a,
    id: o.buttonId,
    type: T,
    "aria-expanded": t.disabled ? void 0 : o.disclosureState === 0,
    "aria-controls": o.linkedPanel ? o.panelId : void 0,
    onKeyDown: u,
    onKeyUp: c,
    onClick: m
  };

  return E({
    props: _objectSpread(_objectSpread({}, y), p),
    slot: b,
    defaultTag: wn,
    name: "Disclosure.Button"
  });
}),
    _n = "div",
    Gn = 1 | 2,
    Hn = D(function (t, r) {
  var _Ft3 = Ft("Disclosure.Panel"),
      _Ft4 = _slicedToArray(_Ft3, 2),
      o = _Ft4[0],
      n = _Ft4[1],
      _Ao = Ao("Disclosure.Panel"),
      i = _Ao.close,
      a = I(r, function () {
    o.linkedPanel || n({
      type: 4
    });
  }),
      l = _(),
      s = function () {
    return l !== null ? l === 0 : o.disclosureState === 0;
  }();

  qe(function () {
    return function () {
      return n({
        type: 5
      });
    };
  }, [n]), qe(function () {
    var b;
    o.disclosureState === 1 && ((b = t.unmount) != null ? b : !0) && n({
      type: 5
    });
  }, [o.disclosureState, t.unmount, n]);
  var u = ze(function () {
    return {
      open: o.disclosureState === 0,
      close: i
    };
  }, [o, i]),
      c = {
    ref: a,
    id: o.panelId
  },
      m = t;
  return $e.createElement(kt.Provider, {
    value: o.panelId
  }, E({
    props: _objectSpread(_objectSpread({}, m), c),
    slot: u,
    defaultTag: _n,
    features: Gn,
    visible: s,
    name: "Disclosure.Panel"
  }));
});
Ye.Button = kn;
Ye.Panel = Hn;
import { useRef as Un } from "react";
var Bn = "div";

function yu(e) {
  var t = Un(null),
      r = e.initialFocus,
      o = _objectWithoutProperties(e, _excluded11),
      n = q();

  return Ne(t, n ? 30 : 1, {
    initialFocus: r
  }), E({
    props: _objectSpread(_objectSpread({}, o), {
      ref: t
    }),
    defaultTag: Bn,
    name: "FocusTrap"
  });
}

import Oo, { Fragment as Nn, createContext as Wn, createRef as _t, useCallback as z, useContext as Kn, useMemo as ve, useReducer as jn, useRef as Vn } from "react";
var $n = (_$n = {}, _defineProperty(_$n, 1, function _(e) {
  return e.disabled || e.listboxState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
    activeOptionIndex: null,
    listboxState: 1
  });
}), _defineProperty(_$n, 0, function _(e) {
  return e.disabled || e.listboxState === 0 ? e : _objectSpread(_objectSpread({}, e), {}, {
    listboxState: 0
  });
}), _defineProperty(_$n, 2, function _(e, t) {
  return e.disabled === t.disabled ? e : _objectSpread(_objectSpread({}, e), {}, {
    disabled: t.disabled
  });
}), _defineProperty(_$n, 3, function _(e, t) {
  return e.orientation === t.orientation ? e : _objectSpread(_objectSpread({}, e), {}, {
    orientation: t.orientation
  });
}), _defineProperty(_$n, 4, function _(e, t) {
  if (e.disabled || e.listboxState === 1) return e;
  var r = ae(t, {
    resolveItems: function resolveItems() {
      return e.options;
    },
    resolveActiveIndex: function resolveActiveIndex() {
      return e.activeOptionIndex;
    },
    resolveId: function resolveId(o) {
      return o.id;
    },
    resolveDisabled: function resolveDisabled(o) {
      return o.dataRef.current.disabled;
    }
  });
  return e.searchQuery === "" && e.activeOptionIndex === r ? e : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: "",
    activeOptionIndex: r
  });
}), _defineProperty(_$n, 5, function _(e, t) {
  if (e.disabled || e.listboxState === 1) return e;
  var o = e.searchQuery !== "" ? 0 : 1,
      n = e.searchQuery + t.value.toLowerCase(),
      a = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + o).concat(e.options.slice(0, e.activeOptionIndex + o)) : e.options).find(function (s) {
    var u;
    return !s.dataRef.current.disabled && ((u = s.dataRef.current.textValue) == null ? void 0 : u.startsWith(n));
  }),
      l = a ? e.options.indexOf(a) : -1;
  return l === -1 || l === e.activeOptionIndex ? _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: n
  }) : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: n,
    activeOptionIndex: l
  });
}), _defineProperty(_$n, 6, function _(e) {
  return e.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: ""
  });
}), _defineProperty(_$n, 7, function _(e, t) {
  var n;
  var r = Array.from((n = e.optionsRef.current) == null ? void 0 : n.querySelectorAll('[id^="headlessui-listbox-option-"]')).reduce(function (i, a, l) {
    return Object.assign(i, _defineProperty({}, a.id, l));
  }, {}),
      o = [].concat(_toConsumableArray(e.options), [{
    id: t.id,
    dataRef: t.dataRef
  }]).sort(function (i, a) {
    return r[i.id] - r[a.id];
  });
  return _objectSpread(_objectSpread({}, e), {}, {
    options: o
  });
}), _defineProperty(_$n, 8, function _(e, t) {
  var r = e.options.slice(),
      o = e.activeOptionIndex !== null ? r[e.activeOptionIndex] : null,
      n = r.findIndex(function (i) {
    return i.id === t.id;
  });
  return n !== -1 && r.splice(n, 1), _objectSpread(_objectSpread({}, e), {}, {
    options: r,
    activeOptionIndex: function () {
      return n === e.activeOptionIndex || o === null ? null : r.indexOf(o);
    }()
  });
}), _$n),
    Gt = Wn(null);
Gt.displayName = "ListboxContext";

function Re(e) {
  var t = Kn(Gt);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <").concat(Ee.name, " /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, Re), r;
  }

  return t;
}

function Qn(e, t) {
  return S(t.type, $n, e, t);
}

var qn = Nn;

function Ee(e) {
  var _S10;

  var t = e.value,
      r = e.onChange,
      _e$disabled2 = e.disabled,
      o = _e$disabled2 === void 0 ? !1 : _e$disabled2,
      _e$horizontal = e.horizontal,
      n = _e$horizontal === void 0 ? !1 : _e$horizontal,
      i = _objectWithoutProperties(e, _excluded12),
      a = n ? "horizontal" : "vertical",
      l = jn(Qn, {
    listboxState: 1,
    propsRef: {
      current: {
        value: t,
        onChange: r
      }
    },
    labelRef: _t(),
    buttonRef: _t(),
    optionsRef: _t(),
    disabled: o,
    orientation: a,
    options: [],
    searchQuery: "",
    activeOptionIndex: null
  }),
      _l2 = _slicedToArray(l, 2),
      _l2$ = _l2[0],
      s = _l2$.listboxState,
      u = _l2$.propsRef,
      c = _l2$.optionsRef,
      m = _l2$.buttonRef,
      b = _l2[1];

  x(function () {
    u.current.value = t;
  }, [t, u]), x(function () {
    u.current.onChange = r;
  }, [r, u]), x(function () {
    return b({
      type: 2,
      disabled: o
    });
  }, [o]), x(function () {
    return b({
      type: 3,
      orientation: a
    });
  }, [a]), w("mousedown", function (y) {
    var f, d, P;
    var p = y.target;
    s === 0 && (((f = m.current) == null ? void 0 : f.contains(p)) || ((d = c.current) == null ? void 0 : d.contains(p)) || (b({
      type: 1
    }), de(p, 1) || (y.preventDefault(), (P = m.current) == null || P.focus())));
  });
  var T = ve(function () {
    return {
      open: s === 0,
      disabled: o
    };
  }, [s, o]);
  return Oo.createElement(Gt.Provider, {
    value: l
  }, Oo.createElement(W, {
    value: S(s, (_S10 = {}, _defineProperty(_S10, 0, 0), _defineProperty(_S10, 1, 1), _S10))
  }, E({
    props: i,
    slot: T,
    defaultTag: qn,
    name: "Listbox"
  })));
}

var zn = "button",
    Yn = D(function (t, r) {
  var p;

  var _Re = Re("Listbox.Button"),
      _Re2 = _slicedToArray(_Re, 2),
      o = _Re2[0],
      n = _Re2[1],
      i = I(o.buttonRef, r),
      a = "headlessui-listbox-button-".concat(A()),
      l = Q(),
      s = z(function (f) {
    switch (f.key) {
      case " ":
      case "Enter":
      case "ArrowDown":
        f.preventDefault(), n({
          type: 0
        }), l.nextFrame(function () {
          o.propsRef.current.value || n({
            type: 4,
            focus: 0
          });
        });
        break;

      case "ArrowUp":
        f.preventDefault(), n({
          type: 0
        }), l.nextFrame(function () {
          o.propsRef.current.value || n({
            type: 4,
            focus: 3
          });
        });
        break;
    }
  }, [n, o, l]),
      u = z(function (f) {
    switch (f.key) {
      case " ":
        f.preventDefault();
        break;
    }
  }, []),
      c = z(function (f) {
    if (G(f.currentTarget)) return f.preventDefault();
    o.listboxState === 0 ? (n({
      type: 1
    }), l.nextFrame(function () {
      var d;
      return (d = o.buttonRef.current) == null ? void 0 : d.focus({
        preventScroll: !0
      });
    })) : (f.preventDefault(), n({
      type: 0
    }));
  }, [n, l, o]),
      m = ee(function () {
    if (!!o.labelRef.current) return [o.labelRef.current.id, a].join(" ");
  }, [o.labelRef.current, a]),
      b = ve(function () {
    return {
      open: o.listboxState === 0,
      disabled: o.disabled
    };
  }, [o]),
      T = t,
      y = {
    ref: i,
    id: a,
    type: U(t, o.buttonRef),
    "aria-haspopup": !0,
    "aria-controls": (p = o.optionsRef.current) == null ? void 0 : p.id,
    "aria-expanded": o.disabled ? void 0 : o.listboxState === 0,
    "aria-labelledby": m,
    disabled: o.disabled,
    onKeyDown: s,
    onKeyUp: u,
    onClick: c
  };

  return E({
    props: _objectSpread(_objectSpread({}, T), y),
    slot: b,
    defaultTag: zn,
    name: "Listbox.Button"
  });
}),
    Xn = "label";

function Jn(e) {
  var _Re3 = Re("Listbox.Label"),
      _Re4 = _slicedToArray(_Re3, 1),
      t = _Re4[0],
      r = "headlessui-listbox-label-".concat(A()),
      o = z(function () {
    var a;
    return (a = t.buttonRef.current) == null ? void 0 : a.focus({
      preventScroll: !0
    });
  }, [t.buttonRef]),
      n = ve(function () {
    return {
      open: t.listboxState === 0,
      disabled: t.disabled
    };
  }, [t]),
      i = {
    ref: t.labelRef,
    id: r,
    onClick: o
  };

  return E({
    props: _objectSpread(_objectSpread({}, e), i),
    slot: n,
    defaultTag: Xn,
    name: "Listbox.Label"
  });
}

var Zn = "ul",
    ei = 1 | 2,
    ti = D(function (t, r) {
  var f;

  var _Re5 = Re("Listbox.Options"),
      _Re6 = _slicedToArray(_Re5, 2),
      o = _Re6[0],
      n = _Re6[1],
      i = I(o.optionsRef, r),
      a = "headlessui-listbox-options-".concat(A()),
      l = Q(),
      s = Q(),
      u = _(),
      c = function () {
    return u !== null ? u === 0 : o.listboxState === 0;
  }();

  x(function () {
    var d = o.optionsRef.current;
    !d || o.listboxState === 0 && d !== document.activeElement && d.focus({
      preventScroll: !0
    });
  }, [o.listboxState, o.optionsRef]);
  var m = z(function (d) {
    switch (s.dispose(), d.key) {
      case " ":
        if (o.searchQuery !== "") return d.preventDefault(), d.stopPropagation(), n({
          type: 5,
          value: d.key
        });

      case "Enter":
        if (d.preventDefault(), d.stopPropagation(), n({
          type: 1
        }), o.activeOptionIndex !== null) {
          var P = o.options[o.activeOptionIndex].dataRef;
          o.propsRef.current.onChange(P.current.value);
        }

        k().nextFrame(function () {
          var P;
          return (P = o.buttonRef.current) == null ? void 0 : P.focus({
            preventScroll: !0
          });
        });
        break;

      case S(o.orientation, {
        vertical: "ArrowDown",
        horizontal: "ArrowRight"
      }):
        return d.preventDefault(), d.stopPropagation(), n({
          type: 4,
          focus: 2
        });

      case S(o.orientation, {
        vertical: "ArrowUp",
        horizontal: "ArrowLeft"
      }):
        return d.preventDefault(), d.stopPropagation(), n({
          type: 4,
          focus: 1
        });

      case "Home":
      case "PageUp":
        return d.preventDefault(), d.stopPropagation(), n({
          type: 4,
          focus: 0
        });

      case "End":
      case "PageDown":
        return d.preventDefault(), d.stopPropagation(), n({
          type: 4,
          focus: 3
        });

      case "Escape":
        return d.preventDefault(), d.stopPropagation(), n({
          type: 1
        }), l.nextFrame(function () {
          var P;
          return (P = o.buttonRef.current) == null ? void 0 : P.focus({
            preventScroll: !0
          });
        });

      case "Tab":
        d.preventDefault(), d.stopPropagation();
        break;

      default:
        d.key.length === 1 && (n({
          type: 5,
          value: d.key
        }), s.setTimeout(function () {
          return n({
            type: 6
          });
        }, 350));
        break;
    }
  }, [l, n, s, o]),
      b = ee(function () {
    var d, P, C;
    return (C = (d = o.labelRef.current) == null ? void 0 : d.id) != null ? C : (P = o.buttonRef.current) == null ? void 0 : P.id;
  }, [o.labelRef.current, o.buttonRef.current]),
      T = ve(function () {
    return {
      open: o.listboxState === 0
    };
  }, [o]),
      y = {
    "aria-activedescendant": o.activeOptionIndex === null || (f = o.options[o.activeOptionIndex]) == null ? void 0 : f.id,
    "aria-labelledby": b,
    "aria-orientation": o.orientation,
    id: a,
    onKeyDown: m,
    role: "listbox",
    tabIndex: 0,
    ref: i
  };
  return E({
    props: _objectSpread(_objectSpread({}, t), y),
    slot: T,
    defaultTag: Zn,
    features: ei,
    visible: c,
    name: "Listbox.Options"
  });
}),
    oi = "li";

function ri(e) {
  var _e$disabled3 = e.disabled,
      t = _e$disabled3 === void 0 ? !1 : _e$disabled3,
      r = e.value,
      o = _objectWithoutProperties(e, _excluded13),
      _Re7 = Re("Listbox.Option"),
      _Re8 = _slicedToArray(_Re7, 2),
      n = _Re8[0],
      i = _Re8[1],
      a = "headlessui-listbox-option-".concat(A()),
      l = n.activeOptionIndex !== null ? n.options[n.activeOptionIndex].id === a : !1,
      s = n.propsRef.current.value === r,
      u = Vn({
    disabled: t,
    value: r
  });

  x(function () {
    u.current.disabled = t;
  }, [u, t]), x(function () {
    u.current.value = r;
  }, [u, r]), x(function () {
    var d, P;
    u.current.textValue = (P = (d = document.getElementById(a)) == null ? void 0 : d.textContent) == null ? void 0 : P.toLowerCase();
  }, [u, a]);
  var c = z(function () {
    return n.propsRef.current.onChange(r);
  }, [n.propsRef, r]);
  x(function () {
    return i({
      type: 7,
      id: a,
      dataRef: u
    }), function () {
      return i({
        type: 8,
        id: a
      });
    };
  }, [u, a]), x(function () {
    var d, P;
    n.listboxState === 0 && (!s || (i({
      type: 4,
      focus: 4,
      id: a
    }), (P = (d = document.getElementById(a)) == null ? void 0 : d.focus) == null || P.call(d)));
  }, [n.listboxState]), x(function () {
    if (n.listboxState !== 0 || !l) return;
    var d = k();
    return d.requestAnimationFrame(function () {
      var P, C;
      (C = (P = document.getElementById(a)) == null ? void 0 : P.scrollIntoView) == null || C.call(P, {
        block: "nearest"
      });
    }), d.dispose;
  }, [a, l, n.listboxState, n.activeOptionIndex]);
  var m = z(function (d) {
    if (t) return d.preventDefault();
    c(), i({
      type: 1
    }), k().nextFrame(function () {
      var P;
      return (P = n.buttonRef.current) == null ? void 0 : P.focus({
        preventScroll: !0
      });
    });
  }, [i, n.buttonRef, t, c]),
      b = z(function () {
    if (t) return i({
      type: 4,
      focus: 5
    });
    i({
      type: 4,
      focus: 4,
      id: a
    });
  }, [t, a, i]),
      T = z(function () {
    t || l || i({
      type: 4,
      focus: 4,
      id: a
    });
  }, [t, l, a, i]),
      y = z(function () {
    t || !l || i({
      type: 4,
      focus: 5
    });
  }, [t, l, i]),
      p = ve(function () {
    return {
      active: l,
      selected: s,
      disabled: t
    };
  }, [l, s, t]);
  return E({
    props: _objectSpread(_objectSpread({}, o), {
      id: a,
      role: "option",
      tabIndex: t === !0 ? void 0 : -1,
      "aria-disabled": t === !0 ? !0 : void 0,
      "aria-selected": s === !0 ? !0 : void 0,
      disabled: void 0,
      onClick: m,
      onFocus: b,
      onPointerMove: T,
      onMouseMove: T,
      onPointerLeave: y,
      onMouseLeave: y
    }),
    slot: p,
    defaultTag: oi,
    name: "Listbox.Option"
  });
}

Ee.Button = Yn;
Ee.Label = Jn;
Ee.Options = ti;
Ee.Option = ri;
import Io, { Fragment as Lo, createContext as ni, createRef as Do, useCallback as Y, useContext as ii, useEffect as li, useMemo as Xe, useReducer as ai, useRef as si } from "react";
var ui = (_ui = {}, _defineProperty(_ui, 1, function _(e) {
  return e.menuState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
    activeItemIndex: null,
    menuState: 1
  });
}), _defineProperty(_ui, 0, function _(e) {
  return e.menuState === 0 ? e : _objectSpread(_objectSpread({}, e), {}, {
    menuState: 0
  });
}), _defineProperty(_ui, 2, function _(e, t) {
  var r = ae(t, {
    resolveItems: function resolveItems() {
      return e.items;
    },
    resolveActiveIndex: function resolveActiveIndex() {
      return e.activeItemIndex;
    },
    resolveId: function resolveId(o) {
      return o.id;
    },
    resolveDisabled: function resolveDisabled(o) {
      return o.dataRef.current.disabled;
    }
  });
  return e.searchQuery === "" && e.activeItemIndex === r ? e : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: "",
    activeItemIndex: r
  });
}), _defineProperty(_ui, 3, function _(e, t) {
  var o = e.searchQuery !== "" ? 0 : 1,
      n = e.searchQuery + t.value.toLowerCase(),
      a = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + o).concat(e.items.slice(0, e.activeItemIndex + o)) : e.items).find(function (s) {
    var u;
    return ((u = s.dataRef.current.textValue) == null ? void 0 : u.startsWith(n)) && !s.dataRef.current.disabled;
  }),
      l = a ? e.items.indexOf(a) : -1;
  return l === -1 || l === e.activeItemIndex ? _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: n
  }) : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: n,
    activeItemIndex: l
  });
}), _defineProperty(_ui, 4, function _(e) {
  return e.searchQuery === "" ? e : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: "",
    searchActiveItemIndex: null
  });
}), _defineProperty(_ui, 5, function _(e, t) {
  var n;
  var r = Array.from((n = e.itemsRef.current) == null ? void 0 : n.querySelectorAll('[id^="headlessui-menu-item-"]')).reduce(function (i, a, l) {
    return Object.assign(i, _defineProperty({}, a.id, l));
  }, {}),
      o = [].concat(_toConsumableArray(e.items), [{
    id: t.id,
    dataRef: t.dataRef
  }]).sort(function (i, a) {
    return r[i.id] - r[a.id];
  });
  return _objectSpread(_objectSpread({}, e), {}, {
    items: o
  });
}), _defineProperty(_ui, 6, function _(e, t) {
  var r = e.items.slice(),
      o = e.activeItemIndex !== null ? r[e.activeItemIndex] : null,
      n = r.findIndex(function (i) {
    return i.id === t.id;
  });
  return n !== -1 && r.splice(n, 1), _objectSpread(_objectSpread({}, e), {}, {
    items: r,
    activeItemIndex: function () {
      return n === e.activeItemIndex || o === null ? null : r.indexOf(o);
    }()
  });
}), _ui),
    Ht = ni(null);
Ht.displayName = "MenuContext";

function Je(e) {
  var t = ii(Ht);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <").concat(Ze.name, " /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, Je), r;
  }

  return t;
}

function pi(e, t) {
  return S(t.type, ui, e, t);
}

var di = Lo;

function Ze(e) {
  var _S11;

  var t = ai(pi, {
    menuState: 1,
    buttonRef: Do(),
    itemsRef: Do(),
    items: [],
    searchQuery: "",
    activeItemIndex: null
  }),
      _t2 = _slicedToArray(t, 2),
      _t2$ = _t2[0],
      r = _t2$.menuState,
      o = _t2$.itemsRef,
      n = _t2$.buttonRef,
      i = _t2[1];

  w("mousedown", function (l) {
    var u, c, m;
    var s = l.target;
    r === 0 && (((u = n.current) == null ? void 0 : u.contains(s)) || ((c = o.current) == null ? void 0 : c.contains(s)) || (i({
      type: 1
    }), de(s, 1) || (l.preventDefault(), (m = n.current) == null || m.focus())));
  });
  var a = Xe(function () {
    return {
      open: r === 0
    };
  }, [r]);
  return Io.createElement(Ht.Provider, {
    value: t
  }, Io.createElement(W, {
    value: S(r, (_S11 = {}, _defineProperty(_S11, 0, 0), _defineProperty(_S11, 1, 1), _S11))
  }, E({
    props: e,
    slot: a,
    defaultTag: di,
    name: "Menu"
  })));
}

var ci = "button",
    fi = D(function (t, r) {
  var y;

  var _Je = Je("Menu.Button"),
      _Je2 = _slicedToArray(_Je, 2),
      o = _Je2[0],
      n = _Je2[1],
      i = I(o.buttonRef, r),
      a = "headlessui-menu-button-".concat(A()),
      l = Q(),
      s = Y(function (p) {
    switch (p.key) {
      case " ":
      case "Enter":
      case "ArrowDown":
        p.preventDefault(), p.stopPropagation(), n({
          type: 0
        }), l.nextFrame(function () {
          return n({
            type: 2,
            focus: 0
          });
        });
        break;

      case "ArrowUp":
        p.preventDefault(), p.stopPropagation(), n({
          type: 0
        }), l.nextFrame(function () {
          return n({
            type: 2,
            focus: 3
          });
        });
        break;
    }
  }, [n, l]),
      u = Y(function (p) {
    switch (p.key) {
      case " ":
        p.preventDefault();
        break;
    }
  }, []),
      c = Y(function (p) {
    if (G(p.currentTarget)) return p.preventDefault();
    t.disabled || (o.menuState === 0 ? (n({
      type: 1
    }), l.nextFrame(function () {
      var f;
      return (f = o.buttonRef.current) == null ? void 0 : f.focus({
        preventScroll: !0
      });
    })) : (p.preventDefault(), p.stopPropagation(), n({
      type: 0
    })));
  }, [n, l, o, t.disabled]),
      m = Xe(function () {
    return {
      open: o.menuState === 0
    };
  }, [o]),
      b = t,
      T = {
    ref: i,
    id: a,
    type: U(t, o.buttonRef),
    "aria-haspopup": !0,
    "aria-controls": (y = o.itemsRef.current) == null ? void 0 : y.id,
    "aria-expanded": t.disabled ? void 0 : o.menuState === 0,
    onKeyDown: s,
    onKeyUp: u,
    onClick: c
  };

  return E({
    props: _objectSpread(_objectSpread({}, b), T),
    slot: m,
    defaultTag: ci,
    name: "Menu.Button"
  });
}),
    mi = "div",
    bi = 1 | 2,
    Ti = D(function (t, r) {
  var p, f;

  var _Je3 = Je("Menu.Items"),
      _Je4 = _slicedToArray(_Je3, 2),
      o = _Je4[0],
      n = _Je4[1],
      i = I(o.itemsRef, r),
      a = "headlessui-menu-items-".concat(A()),
      l = Q(),
      s = _(),
      u = function () {
    return s !== null ? s === 0 : o.menuState === 0;
  }();

  li(function () {
    var d = o.itemsRef.current;
    !d || o.menuState === 0 && d !== document.activeElement && d.focus({
      preventScroll: !0
    });
  }, [o.menuState, o.itemsRef]), se({
    container: o.itemsRef.current,
    enabled: o.menuState === 0,
    accept: function accept(d) {
      return d.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : d.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(d) {
      d.setAttribute("role", "none");
    }
  });
  var c = Y(function (d) {
    var P;

    switch (l.dispose(), d.key) {
      case " ":
        if (o.searchQuery !== "") return d.preventDefault(), d.stopPropagation(), n({
          type: 3,
          value: d.key
        });

      case "Enter":
        if (d.preventDefault(), d.stopPropagation(), n({
          type: 1
        }), o.activeItemIndex !== null) {
          var C = o.items[o.activeItemIndex].id;
          (P = document.getElementById(C)) == null || P.click();
        }

        k().nextFrame(function () {
          var C;
          return (C = o.buttonRef.current) == null ? void 0 : C.focus({
            preventScroll: !0
          });
        });
        break;

      case "ArrowDown":
        return d.preventDefault(), d.stopPropagation(), n({
          type: 2,
          focus: 2
        });

      case "ArrowUp":
        return d.preventDefault(), d.stopPropagation(), n({
          type: 2,
          focus: 1
        });

      case "Home":
      case "PageUp":
        return d.preventDefault(), d.stopPropagation(), n({
          type: 2,
          focus: 0
        });

      case "End":
      case "PageDown":
        return d.preventDefault(), d.stopPropagation(), n({
          type: 2,
          focus: 3
        });

      case "Escape":
        d.preventDefault(), d.stopPropagation(), n({
          type: 1
        }), k().nextFrame(function () {
          var C;
          return (C = o.buttonRef.current) == null ? void 0 : C.focus({
            preventScroll: !0
          });
        });
        break;

      case "Tab":
        d.preventDefault(), d.stopPropagation();
        break;

      default:
        d.key.length === 1 && (n({
          type: 3,
          value: d.key
        }), l.setTimeout(function () {
          return n({
            type: 4
          });
        }, 350));
        break;
    }
  }, [n, l, o]),
      m = Y(function (d) {
    switch (d.key) {
      case " ":
        d.preventDefault();
        break;
    }
  }, []),
      b = Xe(function () {
    return {
      open: o.menuState === 0
    };
  }, [o]),
      T = {
    "aria-activedescendant": o.activeItemIndex === null || (p = o.items[o.activeItemIndex]) == null ? void 0 : p.id,
    "aria-labelledby": (f = o.buttonRef.current) == null ? void 0 : f.id,
    id: a,
    onKeyDown: c,
    onKeyUp: m,
    role: "menu",
    tabIndex: 0,
    ref: i
  };
  return E({
    props: _objectSpread(_objectSpread({}, t), T),
    slot: b,
    defaultTag: mi,
    features: bi,
    visible: u,
    name: "Menu.Items"
  });
}),
    yi = Lo;

function gi(e) {
  var _e$disabled4 = e.disabled,
      t = _e$disabled4 === void 0 ? !1 : _e$disabled4,
      r = e.onClick,
      o = _objectWithoutProperties(e, _excluded14),
      _Je5 = Je("Menu.Item"),
      _Je6 = _slicedToArray(_Je5, 2),
      n = _Je6[0],
      i = _Je6[1],
      a = "headlessui-menu-item-".concat(A()),
      l = n.activeItemIndex !== null ? n.items[n.activeItemIndex].id === a : !1;

  x(function () {
    if (n.menuState !== 0 || !l) return;
    var p = k();
    return p.requestAnimationFrame(function () {
      var f, d;
      (d = (f = document.getElementById(a)) == null ? void 0 : f.scrollIntoView) == null || d.call(f, {
        block: "nearest"
      });
    }), p.dispose;
  }, [a, l, n.menuState, n.activeItemIndex]);
  var s = si({
    disabled: t
  });
  x(function () {
    s.current.disabled = t;
  }, [s, t]), x(function () {
    var p, f;
    s.current.textValue = (f = (p = document.getElementById(a)) == null ? void 0 : p.textContent) == null ? void 0 : f.toLowerCase();
  }, [s, a]), x(function () {
    return i({
      type: 5,
      id: a,
      dataRef: s
    }), function () {
      return i({
        type: 6,
        id: a
      });
    };
  }, [s, a]);
  var u = Y(function (p) {
    if (t) return p.preventDefault();
    if (i({
      type: 1
    }), k().nextFrame(function () {
      var f;
      return (f = n.buttonRef.current) == null ? void 0 : f.focus({
        preventScroll: !0
      });
    }), r) return r(p);
  }, [i, n.buttonRef, t, r]),
      c = Y(function () {
    if (t) return i({
      type: 2,
      focus: 5
    });
    i({
      type: 2,
      focus: 4,
      id: a
    });
  }, [t, a, i]),
      m = Y(function () {
    t || l || i({
      type: 2,
      focus: 4,
      id: a
    });
  }, [t, l, a, i]),
      b = Y(function () {
    t || !l || i({
      type: 2,
      focus: 5
    });
  }, [t, l, i]),
      T = Xe(function () {
    return {
      active: l,
      disabled: t
    };
  }, [l, t]);
  return E({
    props: _objectSpread(_objectSpread({}, o), {
      id: a,
      role: "menuitem",
      tabIndex: t === !0 ? void 0 : -1,
      "aria-disabled": t === !0 ? !0 : void 0,
      disabled: void 0,
      onClick: u,
      onFocus: c,
      onPointerMove: m,
      onMouseMove: m,
      onPointerLeave: b,
      onMouseLeave: b
    }),
    slot: T,
    defaultTag: yi,
    name: "Menu.Item"
  });
}

Ze.Button = fi;
Ze.Items = Ti;
Ze.Item = gi;
import Ce, { createContext as et, useCallback as j, useContext as tt, useEffect as be, useMemo as Z, useReducer as Pi, useRef as Se, useState as xi } from "react";
var vi = (_vi = {}, _defineProperty(_vi, 0, function _(e) {
  var _S12;

  return _objectSpread(_objectSpread({}, e), {}, {
    popoverState: S(e.popoverState, (_S12 = {}, _defineProperty(_S12, 0, 1), _defineProperty(_S12, 1, 0), _S12))
  });
}), _defineProperty(_vi, 1, function _(e) {
  return e.popoverState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
    popoverState: 1
  });
}), _defineProperty(_vi, 2, function _(e, t) {
  return e.button === t.button ? e : _objectSpread(_objectSpread({}, e), {}, {
    button: t.button
  });
}), _defineProperty(_vi, 3, function _(e, t) {
  return e.buttonId === t.buttonId ? e : _objectSpread(_objectSpread({}, e), {}, {
    buttonId: t.buttonId
  });
}), _defineProperty(_vi, 4, function _(e, t) {
  return e.panel === t.panel ? e : _objectSpread(_objectSpread({}, e), {}, {
    panel: t.panel
  });
}), _defineProperty(_vi, 5, function _(e, t) {
  return e.panelId === t.panelId ? e : _objectSpread(_objectSpread({}, e), {}, {
    panelId: t.panelId
  });
}), _vi),
    Ut = et(null);
Ut.displayName = "PopoverContext";

function ot(e) {
  var t = tt(Ut);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <").concat(Te.name, " /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, ot), r;
  }

  return t;
}

var Bt = et(null);
Bt.displayName = "PopoverAPIContext";

function Mo(e) {
  var t = tt(Bt);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <").concat(Te.name, " /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, Mo), r;
  }

  return t;
}

var Nt = et(null);
Nt.displayName = "PopoverGroupContext";

function Fo() {
  return tt(Nt);
}

var Wt = et(null);
Wt.displayName = "PopoverPanelContext";

function Ri() {
  return tt(Wt);
}

function Ei(e, t) {
  return S(t.type, vi, e, t);
}

var Ci = "div";

function Te(e) {
  var _S13;

  var t = "headlessui-popover-button-".concat(A()),
      r = "headlessui-popover-panel-".concat(A()),
      o = Pi(Ei, {
    popoverState: 1,
    button: null,
    buttonId: t,
    panel: null,
    panelId: r
  }),
      _o2 = _slicedToArray(o, 2),
      _o2$ = _o2[0],
      n = _o2$.popoverState,
      i = _o2$.button,
      a = _o2$.panel,
      l = _o2[1];

  be(function () {
    return l({
      type: 3,
      buttonId: t
    });
  }, [t, l]), be(function () {
    return l({
      type: 5,
      panelId: r
    });
  }, [r, l]);
  var s = Z(function () {
    return {
      buttonId: t,
      panelId: r,
      close: function close() {
        return l({
          type: 1
        });
      }
    };
  }, [t, r, l]),
      u = Fo(),
      c = u == null ? void 0 : u.registerPopover,
      m = j(function () {
    var p;
    return (p = u == null ? void 0 : u.isFocusWithinPopoverGroup()) != null ? p : (i == null ? void 0 : i.contains(document.activeElement)) || (a == null ? void 0 : a.contains(document.activeElement));
  }, [u, i, a]);
  be(function () {
    return c == null ? void 0 : c(s);
  }, [c, s]), w("focus", function () {
    n === 0 && (m() || !i || !a || l({
      type: 1
    }));
  }, !0), w("mousedown", function (p) {
    var f = p.target;
    n === 0 && ((i == null ? void 0 : i.contains(f)) || (a == null ? void 0 : a.contains(f)) || (l({
      type: 1
    }), de(f, 1) || (p.preventDefault(), i == null || i.focus())));
  });
  var b = j(function (p) {
    l({
      type: 1
    });

    var f = function () {
      return p ? p instanceof HTMLElement ? p : p.current instanceof HTMLElement ? p.current : i : i;
    }();

    f == null || f.focus();
  }, [l, i]),
      T = Z(function () {
    return {
      close: b
    };
  }, [b]),
      y = Z(function () {
    return {
      open: n === 0,
      close: b
    };
  }, [n, b]);
  return Ce.createElement(Ut.Provider, {
    value: o
  }, Ce.createElement(Bt.Provider, {
    value: T
  }, Ce.createElement(W, {
    value: S(n, (_S13 = {}, _defineProperty(_S13, 0, 0), _defineProperty(_S13, 1, 1), _S13))
  }, E({
    props: e,
    slot: y,
    defaultTag: Ci,
    name: "Popover"
  }))));
}

var Si = "button",
    Ai = D(function (t, r) {
  var _ot = ot("Popover.Button"),
      _ot2 = _slicedToArray(_ot, 2),
      o = _ot2[0],
      n = _ot2[1],
      i = Se(null),
      a = Fo(),
      l = a == null ? void 0 : a.closeOthers,
      s = Ri(),
      u = s === null ? !1 : s === o.panelId,
      c = I(i, r, u ? null : function (g) {
    return n({
      type: 2,
      button: g
    });
  }),
      m = I(i, r),
      b = Se(null),
      T = Se(typeof window == "undefined" ? null : document.activeElement);

  w("focus", function () {
    T.current = b.current, b.current = document.activeElement;
  }, !0);
  var y = j(function (g) {
    var v, h;

    if (u) {
      if (o.popoverState === 1) return;

      switch (g.key) {
        case " ":
        case "Enter":
          g.preventDefault(), g.stopPropagation(), n({
            type: 1
          }), (v = o.button) == null || v.focus();
          break;
      }
    } else switch (g.key) {
      case " ":
      case "Enter":
        g.preventDefault(), g.stopPropagation(), o.popoverState === 1 && (l == null || l(o.buttonId)), n({
          type: 0
        });
        break;

      case "Escape":
        if (o.popoverState !== 0) return l == null ? void 0 : l(o.buttonId);
        if (!i.current || !i.current.contains(document.activeElement)) return;
        g.preventDefault(), g.stopPropagation(), n({
          type: 1
        });
        break;

      case "Tab":
        if (o.popoverState !== 0 || !o.panel || !o.button) return;

        if (g.shiftKey) {
          if (!T.current || ((h = o.button) == null ? void 0 : h.contains(T.current)) || o.panel.contains(T.current)) return;
          var O = xe(),
              L = O.indexOf(T.current);
          if (O.indexOf(o.button) > L) return;
          g.preventDefault(), g.stopPropagation(), M(o.panel, 8);
        } else g.preventDefault(), g.stopPropagation(), M(o.panel, 1);

        break;
    }
  }, [n, o.popoverState, o.buttonId, o.button, o.panel, i, l, u]),
      p = j(function (g) {
    var v;
    if (!u && (g.key === " " && g.preventDefault(), o.popoverState === 0 && !!o.panel && !!o.button)) switch (g.key) {
      case "Tab":
        if (!T.current || ((v = o.button) == null ? void 0 : v.contains(T.current)) || o.panel.contains(T.current)) return;
        var h = xe(),
            O = h.indexOf(T.current);
        if (h.indexOf(o.button) > O) return;
        g.preventDefault(), g.stopPropagation(), M(o.panel, 8);
        break;
    }
  }, [o.popoverState, o.panel, o.button, u]),
      f = j(function (g) {
    var v, h;
    G(g.currentTarget) || t.disabled || (u ? (n({
      type: 1
    }), (v = o.button) == null || v.focus()) : (o.popoverState === 1 && (l == null || l(o.buttonId)), (h = o.button) == null || h.focus(), n({
      type: 0
    })));
  }, [n, o.button, o.popoverState, o.buttonId, t.disabled, l, u]),
      d = Z(function () {
    return {
      open: o.popoverState === 0
    };
  }, [o]),
      P = U(t, i),
      C = t,
      R = u ? {
    ref: m,
    type: P,
    onKeyDown: y,
    onClick: f
  } : {
    ref: c,
    id: o.buttonId,
    type: P,
    "aria-expanded": t.disabled ? void 0 : o.popoverState === 0,
    "aria-controls": o.panel ? o.panelId : void 0,
    onKeyDown: y,
    onKeyUp: p,
    onClick: f
  };
  return E({
    props: _objectSpread(_objectSpread({}, C), R),
    slot: d,
    defaultTag: Si,
    name: "Popover.Button"
  });
}),
    hi = "div",
    Oi = 1 | 2,
    Ii = D(function (t, r) {
  var _ot3 = ot("Popover.Overlay"),
      _ot4 = _slicedToArray(_ot3, 2),
      o = _ot4[0].popoverState,
      n = _ot4[1],
      i = I(r),
      a = "headlessui-popover-overlay-".concat(A()),
      l = _(),
      s = function () {
    return l !== null ? l === 0 : o === 0;
  }(),
      u = j(function (T) {
    if (G(T.currentTarget)) return T.preventDefault();
    n({
      type: 1
    });
  }, [n]),
      c = Z(function () {
    return {
      open: o === 0
    };
  }, [o]);

  return E({
    props: _objectSpread(_objectSpread({}, t), {
      ref: i,
      id: a,
      "aria-hidden": !0,
      onClick: u
    }),
    slot: c,
    defaultTag: hi,
    features: Oi,
    visible: s,
    name: "Popover.Overlay"
  });
}),
    Li = "div",
    Di = 1 | 2,
    Mi = D(function (t, r) {
  var _t$focus = t.focus,
      o = _t$focus === void 0 ? !1 : _t$focus,
      n = _objectWithoutProperties(t, _excluded15),
      _ot5 = ot("Popover.Panel"),
      _ot6 = _slicedToArray(_ot5, 2),
      i = _ot6[0],
      a = _ot6[1],
      _Mo = Mo("Popover.Panel"),
      l = _Mo.close,
      s = Se(null),
      u = I(s, r, function (p) {
    a({
      type: 4,
      panel: p
    });
  }),
      c = _(),
      m = function () {
    return c !== null ? c === 0 : i.popoverState === 0;
  }(),
      b = j(function (p) {
    var f;

    switch (p.key) {
      case "Escape":
        if (i.popoverState !== 0 || !s.current || !s.current.contains(document.activeElement)) return;
        p.preventDefault(), p.stopPropagation(), a({
          type: 1
        }), (f = i.button) == null || f.focus();
        break;
    }
  }, [i, s, a]);

  be(function () {
    return function () {
      return a({
        type: 4,
        panel: null
      });
    };
  }, [a]), be(function () {
    var p;
    t.static || i.popoverState === 1 && ((p = t.unmount) != null ? p : !0) && a({
      type: 4,
      panel: null
    });
  }, [i.popoverState, t.unmount, t.static, a]), be(function () {
    if (!o || i.popoverState !== 0 || !s.current) return;
    var p = document.activeElement;
    s.current.contains(p) || M(s.current, 1);
  }, [o, s, i.popoverState]), w("keydown", function (p) {
    var d;
    if (i.popoverState !== 0 || !s.current || p.key !== "Tab" || !document.activeElement || !s.current || !s.current.contains(document.activeElement)) return;
    p.preventDefault();
    var f = M(s.current, p.shiftKey ? 2 : 4);
    if (f === 3) return (d = i.button) == null ? void 0 : d.focus();

    if (f === 1) {
      if (!i.button) return;
      var P = xe(),
          C = P.indexOf(i.button),
          R = P.splice(C + 1).filter(function (g) {
        var v;
        return !((v = s.current) == null ? void 0 : v.contains(g));
      });
      M(R, 1) === 0 && M(document.body, 1);
    }
  }), w("focus", function () {
    var p;
    !o || i.popoverState === 0 && (!s.current || ((p = s.current) == null ? void 0 : p.contains(document.activeElement)) || a({
      type: 1
    }));
  }, !0);
  var T = Z(function () {
    return {
      open: i.popoverState === 0,
      close: l
    };
  }, [i, l]),
      y = {
    ref: u,
    id: i.panelId,
    onKeyDown: b
  };
  return Ce.createElement(Wt.Provider, {
    value: i.panelId
  }, E({
    props: _objectSpread(_objectSpread({}, n), y),
    slot: T,
    defaultTag: Li,
    features: Di,
    visible: m,
    name: "Popover.Panel"
  }));
}),
    Fi = "div";

function wi(e) {
  var t = Se(null),
      _xi = xi([]),
      _xi2 = _slicedToArray(_xi, 2),
      r = _xi2[0],
      o = _xi2[1],
      n = j(function (b) {
    o(function (T) {
      var y = T.indexOf(b);

      if (y !== -1) {
        var p = T.slice();
        return p.splice(y, 1), p;
      }

      return T;
    });
  }, [o]),
      i = j(function (b) {
    return o(function (T) {
      return [].concat(_toConsumableArray(T), [b]);
    }), function () {
      return n(b);
    };
  }, [o, n]),
      a = j(function () {
    var T;
    var b = document.activeElement;
    return ((T = t.current) == null ? void 0 : T.contains(b)) ? !0 : r.some(function (y) {
      var p, f;
      return ((p = document.getElementById(y.buttonId)) == null ? void 0 : p.contains(b)) || ((f = document.getElementById(y.panelId)) == null ? void 0 : f.contains(b));
    });
  }, [t, r]),
      l = j(function (b) {
    var _iterator12 = _createForOfIteratorHelper(r),
        _step12;

    try {
      for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
        var T = _step12.value;
        T.buttonId !== b && T.close();
      }
    } catch (err) {
      _iterator12.e(err);
    } finally {
      _iterator12.f();
    }
  }, [r]),
      s = Z(function () {
    return {
      registerPopover: i,
      unregisterPopover: n,
      isFocusWithinPopoverGroup: a,
      closeOthers: l
    };
  }, [i, n, a, l]),
      u = Z(function () {
    return {};
  }, []),
      c = {
    ref: t
  },
      m = e;

  return Ce.createElement(Nt.Provider, {
    value: s
  }, E({
    props: _objectSpread(_objectSpread({}, m), c),
    slot: u,
    defaultTag: Fi,
    name: "Popover.Group"
  }));
}

Te.Button = Ai;
Te.Overlay = Ii;
Te.Panel = Mi;
Te.Group = wi;
import he, { createContext as Wi, useCallback as ye, useContext as Ki, useMemo as it, useReducer as ji, useRef as Kt } from "react";
import { useState as ki, useCallback as rt } from "react";

function wo() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _ki = ki(e),
      _ki2 = _slicedToArray(_ki, 2),
      t = _ki2[0],
      r = _ki2[1],
      o = rt(function (l) {
    return r(function (s) {
      return s | l;
    });
  }, [r]),
      n = rt(function (l) {
    return Boolean(t & l);
  }, [t]),
      i = rt(function (l) {
    return r(function (s) {
      return s & ~l;
    });
  }, [r]),
      a = rt(function (l) {
    return r(function (s) {
      return s ^ l;
    });
  }, [r]);

  return {
    addFlag: o,
    hasFlag: n,
    removeFlag: i,
    toggleFlag: a
  };
}

import _i, { createContext as Gi, useCallback as Hi, useContext as Ui, useMemo as ko, useState as Bi } from "react";

var _o = Gi(null);

function Go() {
  var e = Ui(_o);

  if (e === null) {
    var t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, Go), t;
  }

  return e;
}

function Ae() {
  var _Bi = Bi([]),
      _Bi2 = _slicedToArray(_Bi, 2),
      e = _Bi2[0],
      t = _Bi2[1];

  return [e.length > 0 ? e.join(" ") : void 0, ko(function () {
    return function (o) {
      var n = Hi(function (a) {
        return t(function (l) {
          return [].concat(_toConsumableArray(l), [a]);
        }), function () {
          return t(function (l) {
            var s = l.slice(),
                u = s.indexOf(a);
            return u !== -1 && s.splice(u, 1), s;
          });
        };
      }, []),
          i = ko(function () {
        return {
          register: n,
          slot: o.slot,
          name: o.name,
          props: o.props
        };
      }, [n, o.slot, o.name, o.props]);
      return _i.createElement(_o.Provider, {
        value: i
      }, o.children);
    };
  }, [t])];
}

var Ni = "label";

function nt(e) {
  var _e$passive = e.passive,
      t = _e$passive === void 0 ? !1 : _e$passive,
      r = _objectWithoutProperties(e, _excluded16),
      o = Go(),
      n = "headlessui-label-".concat(A());

  x(function () {
    return o.register(n);
  }, [n, o.register]);

  var i = _objectSpread(_objectSpread({}, o.props), {}, {
    id: n
  }),
      a = _objectSpread(_objectSpread({}, r), i);

  return t && delete a.onClick, E({
    props: a,
    slot: o.slot || {},
    defaultTag: Ni,
    name: o.name || "Label"
  });
}

var Vi = (_Vi = {}, _defineProperty(_Vi, 0, function _(e, t) {
  return _objectSpread(_objectSpread({}, e), {}, {
    options: [].concat(_toConsumableArray(e.options), [{
      id: t.id,
      element: t.element,
      propsRef: t.propsRef
    }])
  });
}), _defineProperty(_Vi, 1, function _(e, t) {
  var r = e.options.slice(),
      o = e.options.findIndex(function (n) {
    return n.id === t.id;
  });
  return o === -1 ? e : (r.splice(o, 1), _objectSpread(_objectSpread({}, e), {}, {
    options: r
  }));
}), _Vi),
    jt = Wi(null);
jt.displayName = "RadioGroupContext";

function Ho(e) {
  var t = Ki(jt);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <").concat(lt.name, " /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, Ho), r;
  }

  return t;
}

function $i(e, t) {
  return S(t.type, Vi, e, t);
}

var Qi = "div";

function lt(e) {
  var t = e.value,
      r = e.onChange,
      _e$disabled5 = e.disabled,
      o = _e$disabled5 === void 0 ? !1 : _e$disabled5,
      n = _objectWithoutProperties(e, _excluded17),
      _ji = ji($i, {
    options: []
  }),
      _ji2 = _slicedToArray(_ji, 2),
      i = _ji2[0].options,
      a = _ji2[1],
      _Ae = Ae(),
      _Ae2 = _slicedToArray(_Ae, 2),
      l = _Ae2[0],
      s = _Ae2[1],
      _re3 = re(),
      _re4 = _slicedToArray(_re3, 2),
      u = _re4[0],
      c = _re4[1],
      m = "headlessui-radiogroup-".concat(A()),
      b = Kt(null),
      T = it(function () {
    return i.find(function (R) {
      return !R.propsRef.current.disabled;
    });
  }, [i]),
      y = it(function () {
    return i.some(function (R) {
      return R.propsRef.current.value === t;
    });
  }, [i, t]),
      p = ye(function (R) {
    var v;
    if (o || R === t) return !1;
    var g = (v = i.find(function (h) {
      return h.propsRef.current.value === R;
    })) == null ? void 0 : v.propsRef.current;
    return (g == null ? void 0 : g.disabled) ? !1 : (r(R), !0);
  }, [r, t, o, i]);

  se({
    container: b.current,
    accept: function accept(R) {
      return R.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : R.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(R) {
      R.setAttribute("role", "none");
    }
  });
  var f = ye(function (R) {
    if (!b.current) return;
    var v = i.filter(function (h) {
      return h.propsRef.current.disabled === !1;
    }).map(function (h) {
      return h.element.current;
    });

    switch (R.key) {
      case "ArrowLeft":
      case "ArrowUp":
        if (R.preventDefault(), R.stopPropagation(), M(v, 2 | 16) === 2) {
          var O = i.find(function (L) {
            return L.element.current === document.activeElement;
          });
          O && p(O.propsRef.current.value);
        }

        break;

      case "ArrowRight":
      case "ArrowDown":
        if (R.preventDefault(), R.stopPropagation(), M(v, 4 | 16) === 2) {
          var _O = i.find(function (L) {
            return L.element.current === document.activeElement;
          });

          _O && p(_O.propsRef.current.value);
        }

        break;

      case " ":
        {
          R.preventDefault(), R.stopPropagation();
          var h = i.find(function (O) {
            return O.element.current === document.activeElement;
          });
          h && p(h.propsRef.current.value);
        }
        break;
    }
  }, [b, i, p]),
      d = ye(function (R) {
    return a(_objectSpread({
      type: 0
    }, R)), function () {
      return a({
        type: 1,
        id: R.id
      });
    };
  }, [a]),
      P = it(function () {
    return {
      registerOption: d,
      firstOption: T,
      containsCheckedOption: y,
      change: p,
      disabled: o,
      value: t
    };
  }, [d, T, y, p, o, t]),
      C = {
    ref: b,
    id: m,
    role: "radiogroup",
    "aria-labelledby": l,
    "aria-describedby": u,
    onKeyDown: f
  };
  return he.createElement(c, {
    name: "RadioGroup.Description"
  }, he.createElement(s, {
    name: "RadioGroup.Label"
  }, he.createElement(jt.Provider, {
    value: P
  }, E({
    props: _objectSpread(_objectSpread({}, n), C),
    defaultTag: Qi,
    name: "RadioGroup"
  }))));
}

var qi = "div";

function zi(e) {
  var t = Kt(null),
      r = "headlessui-radiogroup-option-".concat(A()),
      _Ae3 = Ae(),
      _Ae4 = _slicedToArray(_Ae3, 2),
      o = _Ae4[0],
      n = _Ae4[1],
      _re5 = re(),
      _re6 = _slicedToArray(_re5, 2),
      i = _re6[0],
      a = _re6[1],
      _wo = wo(1),
      l = _wo.addFlag,
      s = _wo.removeFlag,
      u = _wo.hasFlag,
      c = e.value,
      _e$disabled6 = e.disabled,
      m = _e$disabled6 === void 0 ? !1 : _e$disabled6,
      b = _objectWithoutProperties(e, _excluded18),
      T = Kt({
    value: c,
    disabled: m
  });

  x(function () {
    T.current.value = c;
  }, [c, T]), x(function () {
    T.current.disabled = m;
  }, [m, T]);

  var _Ho = Ho("RadioGroup.Option"),
      y = _Ho.registerOption,
      p = _Ho.disabled,
      f = _Ho.change,
      d = _Ho.firstOption,
      P = _Ho.containsCheckedOption,
      C = _Ho.value;

  x(function () {
    return y({
      id: r,
      element: t,
      propsRef: T
    });
  }, [r, y, t, e]);
  var R = ye(function () {
    var V;
    !f(c) || (l(2), (V = t.current) == null || V.focus());
  }, [l, f, c]),
      g = ye(function () {
    return l(2);
  }, [l]),
      v = ye(function () {
    return s(2);
  }, [s]),
      h = (d == null ? void 0 : d.id) === r,
      O = p || m,
      L = C === c,
      N = {
    ref: t,
    id: r,
    role: "radio",
    "aria-checked": L ? "true" : "false",
    "aria-labelledby": o,
    "aria-describedby": i,
    "aria-disabled": O ? !0 : void 0,
    tabIndex: function () {
      return O ? -1 : L || !P && h ? 0 : -1;
    }(),
    onClick: O ? void 0 : R,
    onFocus: O ? void 0 : g,
    onBlur: O ? void 0 : v
  },
      K = it(function () {
    return {
      checked: L,
      disabled: O,
      active: u(2)
    };
  }, [L, O, u]);
  return he.createElement(a, {
    name: "RadioGroup.Description"
  }, he.createElement(n, {
    name: "RadioGroup.Label"
  }, E({
    props: _objectSpread(_objectSpread({}, b), N),
    slot: K,
    defaultTag: qi,
    name: "RadioGroup.Option"
  })));
}

lt.Option = zi;
lt.Label = nt;
lt.Description = me;
import Vt, { Fragment as Yi, createContext as Xi, useCallback as at, useContext as Ji, useMemo as Uo, useState as Zi, useRef as el } from "react";
var $t = Xi(null);
$t.displayName = "GroupContext";
var tl = Yi;

function ol(e) {
  var _Zi = Zi(null),
      _Zi2 = _slicedToArray(_Zi, 2),
      t = _Zi2[0],
      r = _Zi2[1],
      _Ae5 = Ae(),
      _Ae6 = _slicedToArray(_Ae5, 2),
      o = _Ae6[0],
      n = _Ae6[1],
      _re7 = re(),
      _re8 = _slicedToArray(_re7, 2),
      i = _re8[0],
      a = _re8[1],
      l = Uo(function () {
    return {
      switch: t,
      setSwitch: r,
      labelledby: o,
      describedby: i
    };
  }, [t, r, o, i]);

  return Vt.createElement(a, {
    name: "Switch.Description"
  }, Vt.createElement(n, {
    name: "Switch.Label",
    props: {
      onClick: function onClick() {
        !t || (t.click(), t.focus({
          preventScroll: !0
        }));
      }
    }
  }, Vt.createElement($t.Provider, {
    value: l
  }, E({
    props: e,
    defaultTag: tl,
    name: "Switch.Group"
  }))));
}

var rl = "button";

function Qt(e) {
  var t = e.checked,
      r = e.onChange,
      o = _objectWithoutProperties(e, _excluded19),
      n = "headlessui-switch-".concat(A()),
      i = Ji($t),
      a = el(null),
      l = I(a, i === null ? null : i.setSwitch),
      s = at(function () {
    return r(!t);
  }, [r, t]),
      u = at(function (y) {
    if (G(y.currentTarget)) return y.preventDefault();
    y.preventDefault(), s();
  }, [s]),
      c = at(function (y) {
    y.key !== "Tab" && y.preventDefault(), y.key === " " && s();
  }, [s]),
      m = at(function (y) {
    return y.preventDefault();
  }, []),
      b = Uo(function () {
    return {
      checked: t
    };
  }, [t]),
      T = {
    id: n,
    ref: l,
    role: "switch",
    type: U(e, a),
    tabIndex: 0,
    "aria-checked": t,
    "aria-labelledby": i == null ? void 0 : i.labelledby,
    "aria-describedby": i == null ? void 0 : i.describedby,
    onClick: u,
    onKeyUp: c,
    onKeyPress: m
  };

  return E({
    props: _objectSpread(_objectSpread({}, o), T),
    slot: b,
    defaultTag: rl,
    name: "Switch"
  });
}

Qt.Group = ol;
Qt.Label = nt;
Qt.Description = me;
import nl, { Fragment as il, createContext as ll, useCallback as qt, useContext as al, useMemo as Oe, useReducer as sl, useRef as st, useEffect as Ie } from "react";
var ul = (_ul = {}, _defineProperty(_ul, 0, function _(e, t) {
  return e.selectedIndex === t.index ? e : _objectSpread(_objectSpread({}, e), {}, {
    selectedIndex: t.index
  });
}), _defineProperty(_ul, 1, function _(e, t) {
  return e.orientation === t.orientation ? e : _objectSpread(_objectSpread({}, e), {}, {
    orientation: t.orientation
  });
}), _defineProperty(_ul, 2, function _(e, t) {
  return e.activation === t.activation ? e : _objectSpread(_objectSpread({}, e), {}, {
    activation: t.activation
  });
}), _defineProperty(_ul, 3, function _(e, t) {
  return e.tabs.includes(t.tab) ? e : _objectSpread(_objectSpread({}, e), {}, {
    tabs: [].concat(_toConsumableArray(e.tabs), [t.tab])
  });
}), _defineProperty(_ul, 4, function _(e, t) {
  return _objectSpread(_objectSpread({}, e), {}, {
    tabs: e.tabs.filter(function (r) {
      return r !== t.tab;
    })
  });
}), _defineProperty(_ul, 5, function _(e, t) {
  return e.panels.includes(t.panel) ? e : _objectSpread(_objectSpread({}, e), {}, {
    panels: [].concat(_toConsumableArray(e.panels), [t.panel])
  });
}), _defineProperty(_ul, 6, function _(e, t) {
  return _objectSpread(_objectSpread({}, e), {}, {
    panels: e.panels.filter(function (r) {
      return r !== t.panel;
    })
  });
}), _defineProperty(_ul, 7, function _(e) {
  return _objectSpread({}, e);
}), _ul),
    zt = ll(null);
zt.displayName = "TabsContext";

function Le(e) {
  var t = al(zt);

  if (t === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, Le), r;
  }

  return t;
}

function pl(e, t) {
  return S(t.type, ul, e, t);
}

var dl = il;

function cl(e) {
  var _e$defaultIndex = e.defaultIndex,
      t = _e$defaultIndex === void 0 ? 0 : _e$defaultIndex,
      _e$vertical = e.vertical,
      r = _e$vertical === void 0 ? !1 : _e$vertical,
      _e$manual = e.manual,
      o = _e$manual === void 0 ? !1 : _e$manual,
      n = e.onChange,
      _e$selectedIndex = e.selectedIndex,
      i = _e$selectedIndex === void 0 ? null : _e$selectedIndex,
      a = _objectWithoutProperties(e, _excluded20),
      l = r ? "vertical" : "horizontal",
      s = o ? "manual" : "auto",
      _sl = sl(pl, {
    selectedIndex: null,
    tabs: [],
    panels: [],
    orientation: l,
    activation: s
  }),
      _sl2 = _slicedToArray(_sl, 2),
      u = _sl2[0],
      c = _sl2[1],
      m = Oe(function () {
    return {
      selectedIndex: u.selectedIndex
    };
  }, [u.selectedIndex]),
      b = st(function () {});

  Ie(function () {
    c({
      type: 1,
      orientation: l
    });
  }, [l]), Ie(function () {
    c({
      type: 2,
      activation: s
    });
  }, [s]), Ie(function () {
    typeof n == "function" && (b.current = n);
  }, [n]), Ie(function () {
    if (u.tabs.length <= 0 || i === null && u.selectedIndex !== null) return;
    var p = u.tabs.map(function (P) {
      return P.current;
    }).filter(Boolean),
        f = p.filter(function (P) {
      return !P.hasAttribute("disabled");
    }),
        d = i != null ? i : t;
    if (d < 0) c({
      type: 0,
      index: p.indexOf(f[0])
    });else if (d > u.tabs.length) c({
      type: 0,
      index: p.indexOf(f[f.length - 1])
    });else {
      var P = p.slice(0, d),
          R = [].concat(_toConsumableArray(p.slice(d)), _toConsumableArray(P)).find(function (g) {
        return f.includes(g);
      });
      if (!R) return;
      c({
        type: 0,
        index: p.indexOf(R)
      });
    }
  }, [t, i, u.tabs, u.selectedIndex]);
  var T = st(u.selectedIndex);
  Ie(function () {
    T.current = u.selectedIndex;
  }, [u.selectedIndex]);
  var y = Oe(function () {
    return [u, {
      dispatch: c,
      change: function change(p) {
        T.current !== p && b.current(p), T.current = p, c({
          type: 0,
          index: p
        });
      }
    }];
  }, [u, c]);
  return nl.createElement(zt.Provider, {
    value: y
  }, E({
    props: _objectSpread({}, a),
    slot: m,
    defaultTag: dl,
    name: "Tabs"
  }));
}

var fl = "div";

function ml(e) {
  var _Le = Le("Tab.List"),
      _Le2 = _slicedToArray(_Le, 1),
      _Le2$ = _Le2[0],
      t = _Le2$.selectedIndex,
      r = _Le2$.orientation,
      o = {
    selectedIndex: t
  };

  return E({
    props: _objectSpread(_objectSpread({}, e), {
      role: "tablist",
      "aria-orientation": r
    }),
    slot: o,
    defaultTag: fl,
    name: "Tabs.List"
  });
}

var bl = "button";

function De(e) {
  var C, R;

  var t = "headlessui-tabs-tab-".concat(A()),
      _Le3 = Le(De.name),
      _Le4 = _slicedToArray(_Le3, 2),
      _Le4$ = _Le4[0],
      r = _Le4$.selectedIndex,
      o = _Le4$.tabs,
      n = _Le4$.panels,
      i = _Le4$.orientation,
      a = _Le4$.activation,
      _Le4$2 = _Le4[1],
      l = _Le4$2.dispatch,
      s = _Le4$2.change,
      u = st(null),
      c = I(u, function (g) {
    !g || l({
      type: 7
    });
  });

  x(function () {
    return l({
      type: 3,
      tab: u
    }), function () {
      return l({
        type: 4,
        tab: u
      });
    };
  }, [l, u]);
  var m = o.indexOf(u),
      b = m === r,
      T = qt(function (g) {
    var v = o.map(function (h) {
      return h.current;
    }).filter(Boolean);

    if (g.key === " " || g.key === "Enter") {
      g.preventDefault(), g.stopPropagation(), s(m);
      return;
    }

    switch (g.key) {
      case "Home":
      case "PageUp":
        return g.preventDefault(), g.stopPropagation(), M(v, 1);

      case "End":
      case "PageDown":
        return g.preventDefault(), g.stopPropagation(), M(v, 8);
    }

    return S(i, {
      vertical: function vertical() {
        if (g.key === "ArrowUp") return M(v, 2 | 16);
        if (g.key === "ArrowDown") return M(v, 4 | 16);
      },
      horizontal: function horizontal() {
        if (g.key === "ArrowLeft") return M(v, 2 | 16);
        if (g.key === "ArrowRight") return M(v, 4 | 16);
      }
    });
  }, [o, i, m, s]),
      y = qt(function () {
    var g;
    (g = u.current) == null || g.focus();
  }, [u]),
      p = qt(function () {
    var g;
    (g = u.current) == null || g.focus(), s(m);
  }, [s, m, u]),
      f = Oe(function () {
    return {
      selected: b
    };
  }, [b]),
      d = {
    ref: c,
    onKeyDown: T,
    onFocus: a === "manual" ? y : p,
    onClick: p,
    id: t,
    role: "tab",
    type: U(e, u),
    "aria-controls": (R = (C = n[m]) == null ? void 0 : C.current) == null ? void 0 : R.id,
    "aria-selected": b,
    tabIndex: b ? 0 : -1
  };
  return E({
    props: _objectSpread(_objectSpread({}, e), d),
    slot: f,
    defaultTag: bl,
    name: "Tabs.Tab"
  });
}

var Tl = "div";

function yl(e) {
  var _Le5 = Le("Tab.Panels"),
      _Le6 = _slicedToArray(_Le5, 1),
      t = _Le6[0].selectedIndex,
      r = Oe(function () {
    return {
      selectedIndex: t
    };
  }, [t]);

  return E({
    props: e,
    slot: r,
    defaultTag: Tl,
    name: "Tabs.Panels"
  });
}

var gl = "div",
    Pl = 1 | 2;

function xl(e) {
  var T, y;

  var _Le7 = Le("Tab.Panel"),
      _Le8 = _slicedToArray(_Le7, 2),
      _Le8$ = _Le8[0],
      t = _Le8$.selectedIndex,
      r = _Le8$.tabs,
      o = _Le8$.panels,
      n = _Le8[1].dispatch,
      i = "headlessui-tabs-panel-".concat(A()),
      a = st(null),
      l = I(a, function (p) {
    !p || n({
      type: 7
    });
  });

  x(function () {
    return n({
      type: 5,
      panel: a
    }), function () {
      return n({
        type: 6,
        panel: a
      });
    };
  }, [n, a]);
  var s = o.indexOf(a),
      u = s === t,
      c = Oe(function () {
    return {
      selected: u
    };
  }, [u]),
      m = {
    ref: l,
    id: i,
    role: "tabpanel",
    "aria-labelledby": (y = (T = r[s]) == null ? void 0 : T.current) == null ? void 0 : y.id,
    tabIndex: u ? 0 : -1
  };
  return E({
    props: _objectSpread(_objectSpread({}, e), m),
    slot: c,
    defaultTag: gl,
    features: Pl,
    visible: u,
    name: "Tabs.Panel"
  });
}

De.Group = cl;
De.List = ml;
De.Panels = yl;
De.Panel = xl;
import ie, { Fragment as Wo, createContext as Ko, useCallback as jo, useContext as Jt, useEffect as pt, useMemo as Zt, useRef as Me, useState as Vo } from "react";
import { useRef as vl, useEffect as Rl } from "react";

function Bo() {
  var e = vl(!0);
  return Rl(function () {
    e.current = !1;
  }, []), e.current;
}

function No(e) {
  var t = {
    called: !1
  };
  return function () {
    if (!t.called) return t.called = !0, e.apply(void 0, arguments);
  };
}

function Yt(e) {
  var _e$classList;

  for (var _len4 = arguments.length, t = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    t[_key4 - 1] = arguments[_key4];
  }

  e && t.length > 0 && (_e$classList = e.classList).add.apply(_e$classList, t);
}

function ut(e) {
  var _e$classList2;

  for (var _len5 = arguments.length, t = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    t[_key5 - 1] = arguments[_key5];
  }

  e && t.length > 0 && (_e$classList2 = e.classList).remove.apply(_e$classList2, t);
}

function El(e, t) {
  var r = k();
  if (!e) return r.dispose;

  var _getComputedStyle = getComputedStyle(e),
      o = _getComputedStyle.transitionDuration,
      n = _getComputedStyle.transitionDelay,
      _map = [o, n].map(function (l) {
    var _l$split$filter$map$s = l.split(",").filter(Boolean).map(function (u) {
      return u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3;
    }).sort(function (u, c) {
      return c - u;
    }),
        _l$split$filter$map$s2 = _slicedToArray(_l$split$filter$map$s, 1),
        _l$split$filter$map$s3 = _l$split$filter$map$s2[0],
        s = _l$split$filter$map$s3 === void 0 ? 0 : _l$split$filter$map$s3;

    return s;
  }),
      _map2 = _slicedToArray(_map, 2),
      i = _map2[0],
      a = _map2[1];

  return i !== 0 ? r.setTimeout(function () {
    t("finished");
  }, i + a) : t("finished"), r.add(function () {
    return t("cancelled");
  }), r.dispose;
}

function Xt(e, t, r, o, n, i) {
  var a = k(),
      l = i !== void 0 ? No(i) : function () {};
  return ut.apply(void 0, [e].concat(_toConsumableArray(n))), Yt.apply(void 0, [e].concat(_toConsumableArray(t), _toConsumableArray(r))), a.nextFrame(function () {
    ut.apply(void 0, [e].concat(_toConsumableArray(r))), Yt.apply(void 0, [e].concat(_toConsumableArray(o))), a.add(El(e, function (s) {
      return ut.apply(void 0, [e].concat(_toConsumableArray(o), _toConsumableArray(t))), Yt.apply(void 0, [e].concat(_toConsumableArray(n))), l(s);
    }));
  }), a.add(function () {
    return ut.apply(void 0, [e].concat(_toConsumableArray(t), _toConsumableArray(r), _toConsumableArray(o), _toConsumableArray(n)));
  }), a.add(function () {
    return l("cancelled");
  }), a.dispose;
}

function le() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return Zt(function () {
    return e.split(" ").filter(function (t) {
      return t.trim().length > 1;
    });
  }, [e]);
}

var dt = Ko(null);
dt.displayName = "TransitionContext";

function Cl() {
  var e = Jt(dt);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}

function Sl() {
  var e = Jt(ct);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}

var ct = Ko(null);
ct.displayName = "NestingContext";

function ft(e) {
  return "children" in e ? ft(e.children) : e.current.filter(function (_ref7) {
    var t = _ref7.state;
    return t === "visible";
  }).length > 0;
}

function $o(e) {
  var t = Me(e),
      r = Me([]),
      o = Be();
  pt(function () {
    t.current = e;
  }, [e]);
  var n = jo(function (a) {
    var _S14;

    var l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var u;
    var s = r.current.findIndex(function (_ref8) {
      var c = _ref8.id;
      return c === a;
    });
    s !== -1 && (S(l, (_S14 = {}, _defineProperty(_S14, 0, function _() {
      r.current.splice(s, 1);
    }), _defineProperty(_S14, 1, function _() {
      r.current[s].state = "hidden";
    }), _S14)), !ft(r) && o.current && ((u = t.current) == null || u.call(t)));
  }, [t, o, r]),
      i = jo(function (a) {
    var l = r.current.find(function (_ref9) {
      var s = _ref9.id;
      return s === a;
    });
    return l ? l.state !== "visible" && (l.state = "visible") : r.current.push({
      id: a,
      state: "visible"
    }), function () {
      return n(a, 0);
    };
  }, [r, n]);
  return Zt(function () {
    return {
      children: r,
      register: i,
      unregister: n
    };
  }, [i, n, r]);
}

function Al() {}

var hl = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];

function Qo(e) {
  var r;
  var t = {};

  var _iterator13 = _createForOfIteratorHelper(hl),
      _step13;

  try {
    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
      var o = _step13.value;
      t[o] = (r = e[o]) != null ? r : Al;
    }
  } catch (err) {
    _iterator13.e(err);
  } finally {
    _iterator13.f();
  }

  return t;
}

function Ol(e) {
  var t = Me(Qo(e));
  return pt(function () {
    t.current = Qo(e);
  }, [e]), t;
}

var Il = "div",
    qo = 1;

function zo(e) {
  var t = e.beforeEnter,
      r = e.afterEnter,
      o = e.beforeLeave,
      n = e.afterLeave,
      i = e.enter,
      a = e.enterFrom,
      l = e.enterTo,
      s = e.entered,
      u = e.leave,
      c = e.leaveFrom,
      m = e.leaveTo,
      b = _objectWithoutProperties(e, _excluded21),
      T = Me(null),
      _Vo = Vo("visible"),
      _Vo2 = _slicedToArray(_Vo, 2),
      y = _Vo2[0],
      p = _Vo2[1],
      f = b.unmount ? 0 : 1,
      _Cl = Cl(),
      d = _Cl.show,
      P = _Cl.appear,
      C = _Cl.initial,
      _Sl = Sl(),
      R = _Sl.register,
      g = _Sl.unregister,
      v = A(),
      h = Me(!1),
      O = $o(function () {
    h.current || (p("hidden"), g(v), X.current.afterLeave());
  });

  x(function () {
    if (!!v) return R(v);
  }, [R, v]), x(function () {
    if (f === 1 && !!v) {
      if (d && y !== "visible") {
        p("visible");
        return;
      }

      S(y, {
        hidden: function hidden() {
          return g(v);
        },
        visible: function visible() {
          return R(v);
        }
      });
    }
  }, [y, v, R, g, d, f]);
  var L = le(i),
      N = le(a),
      K = le(l),
      V = le(s),
      Fe = le(u),
      ge = le(c),
      we = le(m),
      X = Ol({
    beforeEnter: t,
    afterEnter: r,
    beforeLeave: o,
    afterLeave: n
  }),
      F = q();
  pt(function () {
    if (F && y === "visible" && T.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [T, y, F]);
  var $ = C && !P;
  x(function () {
    var bt = T.current;
    if (!!bt && !$) return h.current = !0, d && X.current.beforeEnter(), d || X.current.beforeLeave(), d ? Xt(bt, L, N, K, V, function (Tt) {
      h.current = !1, Tt === "finished" && X.current.afterEnter();
    }) : Xt(bt, Fe, ge, we, V, function (Tt) {
      h.current = !1, Tt === "finished" && (ft(O) || (p("hidden"), g(v), X.current.afterLeave()));
    });
  }, [X, v, h, g, O, T, $, d, L, N, K, Fe, ge, we]);
  var H = {
    ref: T
  },
      Pe = b;
  return ie.createElement(ct.Provider, {
    value: O
  }, ie.createElement(W, {
    value: S(y, {
      visible: 0,
      hidden: 1
    })
  }, E({
    props: _objectSpread(_objectSpread({}, Pe), H),
    defaultTag: Il,
    features: qo,
    visible: y === "visible",
    name: "Transition.Child"
  })));
}

function mt(e) {
  var _S15;

  var t = e.show,
      _e$appear = e.appear,
      r = _e$appear === void 0 ? !1 : _e$appear,
      o = e.unmount,
      n = _objectWithoutProperties(e, _excluded22),
      i = _();

  if (t === void 0 && i !== null && (t = S(i, (_S15 = {}, _defineProperty(_S15, 0, !0), _defineProperty(_S15, 1, !1), _S15))), ![!0, !1].includes(t)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");

  var _Vo3 = Vo(t ? "visible" : "hidden"),
      _Vo4 = _slicedToArray(_Vo3, 2),
      a = _Vo4[0],
      l = _Vo4[1],
      s = $o(function () {
    l("hidden");
  }),
      u = Bo(),
      c = Zt(function () {
    return {
      show: t,
      appear: r || !u,
      initial: u
    };
  }, [t, r, u]);

  pt(function () {
    t ? l("visible") : ft(s) || l("hidden");
  }, [t, s]);
  var m = {
    unmount: o
  };
  return ie.createElement(ct.Provider, {
    value: s
  }, ie.createElement(dt.Provider, {
    value: c
  }, E({
    props: _objectSpread(_objectSpread({}, m), {}, {
      as: Wo,
      children: ie.createElement(zo, _objectSpread(_objectSpread({}, m), n))
    }),
    defaultTag: Wo,
    features: qo,
    visible: a === "visible",
    name: "Transition"
  })));
}

mt.Child = function (t) {
  var r = Jt(dt) !== null,
      o = _() !== null;
  return !r && o ? ie.createElement(mt, _objectSpread({}, t)) : ie.createElement(zo, _objectSpread({}, t));
};

mt.Root = mt;
export { Na as Combobox, An as Dialog, Ye as Disclosure, yu as FocusTrap, Ee as Listbox, Ze as Menu, Te as Popover, We as Portal, lt as RadioGroup, Qt as Switch, De as Tab, mt as Transition };